/* ydui-district v1.1.0 by YDCSS (c) 2017 Licensed ISC */
!function () {
  var district = [{
    "v": "110000",
    "n": "北京市",
    "c": [{
      "v": "110100",
      "n": "北京市",
      "c": [{"v": "110101", "n": "东城区"}, {"v": "110102", "n": "西城区"}, {"v": "110105", "n": "朝阳区"}, {
        "v": "110106",
        "n": "丰台区"
      }, {"v": "110107", "n": "石景山区"}, {"v": "110108", "n": "海淀区"}, {"v": "110109", "n": "门头沟区"}, {
        "v": "110111",
        "n": "房山区"
      }, {"v": "110112", "n": "通州区"}, {"v": "110113", "n": "顺义区"}, {"v": "110114", "n": "昌平区"}, {
        "v": "110115",
        "n": "大兴区"
      }, {"v": "110116", "n": "怀柔区"}, {"v": "110117", "n": "平谷区"}, {"v": "110118", "n": "密云区"}, {
        "v": "110119",
        "n": "延庆区"
      }]
    }]
  }, {
    "v": "120000",
    "n": "天津市",
    "c": [{
      "v": "120100",
      "n": "天津市",
      "c": [{"v": "120101", "n": "和平区"}, {"v": "120102", "n": "河东区"}, {"v": "120103", "n": "河西区"}, {
        "v": "120104",
        "n": "南开区"
      }, {"v": "120105", "n": "河北区"}, {"v": "120106", "n": "红桥区"}, {"v": "120110", "n": "东丽区"}, {
        "v": "120111",
        "n": "西青区"
      }, {"v": "120112", "n": "津南区"}, {"v": "120113", "n": "北辰区"}, {"v": "120114", "n": "武清区"}, {
        "v": "120115",
        "n": "宝坻区"
      }, {"v": "120116", "n": "滨海新区"}, {"v": "120117", "n": "宁河区"}, {"v": "120118", "n": "静海区"}, {
        "v": "120119",
        "n": "蓟州区"
      }]
    }]
  }, {
    "v": "130000",
    "n": "河北省",
    "c": [{
      "v": "130100",
      "n": "石家庄市",
      "c": [{"v": "130102", "n": "长安区"}, {"v": "130104", "n": "桥西区"}, {"v": "130105", "n": "新华区"}, {
        "v": "130107",
        "n": "井陉矿区"
      }, {"v": "130108", "n": "裕华区"}, {"v": "130109", "n": "藁城区"}, {"v": "130110", "n": "鹿泉区"}, {
        "v": "130111",
        "n": "栾城区"
      }, {"v": "130121", "n": "井陉县"}, {"v": "130123", "n": "正定县"}, {"v": "130125", "n": "行唐县"}, {
        "v": "130126",
        "n": "灵寿县"
      }, {"v": "130127", "n": "高邑县"}, {"v": "130128", "n": "深泽县"}, {"v": "130129", "n": "赞皇县"}, {
        "v": "130130",
        "n": "无极县"
      }, {"v": "130131", "n": "平山县"}, {"v": "130132", "n": "元氏县"}, {"v": "130133", "n": "赵县"}, {
        "v": "130181",
        "n": "辛集市"
      }, {"v": "130183", "n": "晋州市"}, {"v": "130184", "n": "新乐市"}]
    }, {
      "v": "130200",
      "n": "唐山市",
      "c": [{"v": "130202", "n": "路南区"}, {"v": "130203", "n": "路北区"}, {"v": "130204", "n": "古冶区"}, {
        "v": "130205",
        "n": "开平区"
      }, {"v": "130207", "n": "丰南区"}, {"v": "130208", "n": "丰润区"}, {"v": "130209", "n": "曹妃甸区"}, {
        "v": "130224",
        "n": "滦南县"
      }, {"v": "130225", "n": "乐亭县"}, {"v": "130227", "n": "迁西县"}, {"v": "130229", "n": "玉田县"}, {
        "v": "130281",
        "n": "遵化市"
      }, {"v": "130283", "n": "迁安市"}, {"v": "130284", "n": "滦州市"}]
    }, {
      "v": "130300",
      "n": "秦皇岛市",
      "c": [{"v": "130302", "n": "海港区"}, {"v": "130303", "n": "山海关区"}, {"v": "130304", "n": "北戴河区"}, {
        "v": "130306",
        "n": "抚宁区"
      }, {"v": "130321", "n": "青龙满族自治县"}, {"v": "130322", "n": "昌黎县"}, {"v": "130324", "n": "卢龙县"}]
    }, {
      "v": "130400",
      "n": "邯郸市",
      "c": [{"v": "130402", "n": "邯山区"}, {"v": "130403", "n": "丛台区"}, {"v": "130404", "n": "复兴区"}, {
        "v": "130406",
        "n": "峰峰矿区"
      }, {"v": "130407", "n": "肥乡区"}, {"v": "130408", "n": "永年区"}, {"v": "130423", "n": "临漳县"}, {
        "v": "130424",
        "n": "成安县"
      }, {"v": "130425", "n": "大名县"}, {"v": "130426", "n": "涉县"}, {"v": "130427", "n": "磁县"}, {
        "v": "130430",
        "n": "邱县"
      }, {"v": "130431", "n": "鸡泽县"}, {"v": "130432", "n": "广平县"}, {"v": "130433", "n": "馆陶县"}, {
        "v": "130434",
        "n": "魏县"
      }, {"v": "130435", "n": "曲周县"}, {"v": "130481", "n": "武安市"}]
    }, {
      "v": "130500",
      "n": "邢台市",
      "c": [{"v": "130502", "n": "桥东区"}, {"v": "130503", "n": "桥西区"}, {"v": "130521", "n": "邢台县"}, {
        "v": "130522",
        "n": "临城县"
      }, {"v": "130523", "n": "内丘县"}, {"v": "130524", "n": "柏乡县"}, {"v": "130525", "n": "隆尧县"}, {
        "v": "130526",
        "n": "任县"
      }, {"v": "130527", "n": "南和县"}, {"v": "130528", "n": "宁晋县"}, {"v": "130529", "n": "巨鹿县"}, {
        "v": "130530",
        "n": "新河县"
      }, {"v": "130531", "n": "广宗县"}, {"v": "130532", "n": "平乡县"}, {"v": "130533", "n": "威县"}, {
        "v": "130534",
        "n": "清河县"
      }, {"v": "130535", "n": "临西县"}, {"v": "130581", "n": "南宫市"}, {"v": "130582", "n": "沙河市"}]
    }, {
      "v": "130600",
      "n": "保定市",
      "c": [{"v": "130602", "n": "竞秀区"}, {"v": "130606", "n": "莲池区"}, {"v": "130607", "n": "满城区"}, {
        "v": "130608",
        "n": "清苑区"
      }, {"v": "130609", "n": "徐水区"}, {"v": "130623", "n": "涞水县"}, {"v": "130624", "n": "阜平县"}, {
        "v": "130626",
        "n": "定兴县"
      }, {"v": "130627", "n": "唐县"}, {"v": "130628", "n": "高阳县"}, {"v": "130629", "n": "容城县"}, {
        "v": "130630",
        "n": "涞源县"
      }, {"v": "130631", "n": "望都县"}, {"v": "130632", "n": "安新县"}, {"v": "130633", "n": "易县"}, {
        "v": "130634",
        "n": "曲阳县"
      }, {"v": "130635", "n": "蠡县"}, {"v": "130636", "n": "顺平县"}, {"v": "130637", "n": "博野县"}, {
        "v": "130638",
        "n": "雄县"
      }, {"v": "130681", "n": "涿州市"}, {"v": "130682", "n": "定州市"}, {"v": "130683", "n": "安国市"}, {
        "v": "130684",
        "n": "高碑店市"
      }]
    }, {
      "v": "130700",
      "n": "张家口市",
      "c": [{"v": "130702", "n": "桥东区"}, {"v": "130703", "n": "桥西区"}, {"v": "130705", "n": "宣化区"}, {
        "v": "130706",
        "n": "下花园区"
      }, {"v": "130708", "n": "万全区"}, {"v": "130709", "n": "崇礼区"}, {"v": "130722", "n": "张北县"}, {
        "v": "130723",
        "n": "康保县"
      }, {"v": "130724", "n": "沽源县"}, {"v": "130725", "n": "尚义县"}, {"v": "130726", "n": "蔚县"}, {
        "v": "130727",
        "n": "阳原县"
      }, {"v": "130728", "n": "怀安县"}, {"v": "130730", "n": "怀来县"}, {"v": "130731", "n": "涿鹿县"}, {
        "v": "130732",
        "n": "赤城县"
      }]
    }, {
      "v": "130800",
      "n": "承德市",
      "c": [{"v": "130802", "n": "双桥区"}, {"v": "130803", "n": "双滦区"}, {"v": "130804", "n": "鹰手营子矿区"}, {
        "v": "130821",
        "n": "承德县"
      }, {"v": "130822", "n": "兴隆县"}, {"v": "130824", "n": "滦平县"}, {"v": "130825", "n": "隆化县"}, {
        "v": "130826",
        "n": "丰宁满族自治县"
      }, {"v": "130827", "n": "宽城满族自治县"}, {"v": "130828", "n": "围场满族蒙古族自治县"}, {"v": "130881", "n": "平泉市"}]
    }, {
      "v": "130900",
      "n": "沧州市",
      "c": [{"v": "130902", "n": "新华区"}, {"v": "130903", "n": "运河区"}, {"v": "130921", "n": "沧县"}, {
        "v": "130922",
        "n": "青县"
      }, {"v": "130923", "n": "东光县"}, {"v": "130924", "n": "海兴县"}, {"v": "130925", "n": "盐山县"}, {
        "v": "130926",
        "n": "肃宁县"
      }, {"v": "130927", "n": "南皮县"}, {"v": "130928", "n": "吴桥县"}, {"v": "130929", "n": "献县"}, {
        "v": "130930",
        "n": "孟村回族自治县"
      }, {"v": "130981", "n": "泊头市"}, {"v": "130982", "n": "任丘市"}, {"v": "130983", "n": "黄骅市"}, {
        "v": "130984",
        "n": "河间市"
      }]
    }, {
      "v": "131000",
      "n": "廊坊市",
      "c": [{"v": "131002", "n": "安次区"}, {"v": "131003", "n": "广阳区"}, {"v": "131022", "n": "固安县"}, {
        "v": "131023",
        "n": "永清县"
      }, {"v": "131024", "n": "香河县"}, {"v": "131025", "n": "大城县"}, {"v": "131026", "n": "文安县"}, {
        "v": "131028",
        "n": "大厂回族自治县"
      }, {"v": "131081", "n": "霸州市"}, {"v": "131082", "n": "三河市"}]
    }, {
      "v": "131100",
      "n": "衡水市",
      "c": [{"v": "131102", "n": "桃城区"}, {"v": "131103", "n": "冀州区"}, {"v": "131121", "n": "枣强县"}, {
        "v": "131122",
        "n": "武邑县"
      }, {"v": "131123", "n": "武强县"}, {"v": "131124", "n": "饶阳县"}, {"v": "131125", "n": "安平县"}, {
        "v": "131126",
        "n": "故城县"
      }, {"v": "131127", "n": "景县"}, {"v": "131128", "n": "阜城县"}, {"v": "131182", "n": "深州市"}]
    }]
  }, {
    "v": "140000",
    "n": "山西省",
    "c": [{
      "v": "140100",
      "n": "太原市",
      "c": [{"v": "140105", "n": "小店区"}, {"v": "140106", "n": "迎泽区"}, {"v": "140107", "n": "杏花岭区"}, {
        "v": "140108",
        "n": "尖草坪区"
      }, {"v": "140109", "n": "万柏林区"}, {"v": "140110", "n": "晋源区"}, {"v": "140121", "n": "清徐县"}, {
        "v": "140122",
        "n": "阳曲县"
      }, {"v": "140123", "n": "娄烦县"}, {"v": "140181", "n": "古交市"}]
    }, {
      "v": "140200",
      "n": "大同市",
      "c": [{"v": "140212", "n": "新荣区"}, {"v": "140213", "n": "平城区"}, {"v": "140214", "n": "云冈区"}, {
        "v": "140215",
        "n": "云州区"
      }, {"v": "140221", "n": "阳高县"}, {"v": "140222", "n": "天镇县"}, {"v": "140223", "n": "广灵县"}, {
        "v": "140224",
        "n": "灵丘县"
      }, {"v": "140225", "n": "浑源县"}, {"v": "140226", "n": "左云县"}]
    }, {
      "v": "140300",
      "n": "阳泉市",
      "c": [{"v": "140302", "n": "城区"}, {"v": "140303", "n": "矿区"}, {"v": "140311", "n": "郊区"}, {
        "v": "140321",
        "n": "平定县"
      }, {"v": "140322", "n": "盂县"}]
    }, {
      "v": "140400",
      "n": "长治市",
      "c": [{"v": "140403", "n": "潞州区"}, {"v": "140404", "n": "上党区"}, {"v": "140405", "n": "屯留区"}, {
        "v": "140406",
        "n": "潞城区"
      }, {"v": "140423", "n": "襄垣县"}, {"v": "140425", "n": "平顺县"}, {"v": "140426", "n": "黎城县"}, {
        "v": "140427",
        "n": "壶关县"
      }, {"v": "140428", "n": "长子县"}, {"v": "140429", "n": "武乡县"}, {"v": "140430", "n": "沁县"}, {
        "v": "140431",
        "n": "沁源县"
      }]
    }, {
      "v": "140500",
      "n": "晋城市",
      "c": [{"v": "140502", "n": "城区"}, {"v": "140521", "n": "沁水县"}, {"v": "140522", "n": "阳城县"}, {
        "v": "140524",
        "n": "陵川县"
      }, {"v": "140525", "n": "泽州县"}, {"v": "140581", "n": "高平市"}]
    }, {
      "v": "140600",
      "n": "朔州市",
      "c": [{"v": "140602", "n": "朔城区"}, {"v": "140603", "n": "平鲁区"}, {"v": "140621", "n": "山阴县"}, {
        "v": "140622",
        "n": "应县"
      }, {"v": "140623", "n": "右玉县"}, {"v": "140681", "n": "怀仁市"}]
    }, {
      "v": "140700",
      "n": "晋中市",
      "c": [{"v": "140702", "n": "榆次区"}, {"v": "140703", "n": "太谷区"}, {"v": "140721", "n": "榆社县"}, {
        "v": "140722",
        "n": "左权县"
      }, {"v": "140723", "n": "和顺县"}, {"v": "140724", "n": "昔阳县"}, {"v": "140725", "n": "寿阳县"}, {
        "v": "140727",
        "n": "祁县"
      }, {"v": "140728", "n": "平遥县"}, {"v": "140729", "n": "灵石县"}, {"v": "140781", "n": "介休市"}]
    }, {
      "v": "140800",
      "n": "运城市",
      "c": [{"v": "140802", "n": "盐湖区"}, {"v": "140821", "n": "临猗县"}, {"v": "140822", "n": "万荣县"}, {
        "v": "140823",
        "n": "闻喜县"
      }, {"v": "140824", "n": "稷山县"}, {"v": "140825", "n": "新绛县"}, {"v": "140826", "n": "绛县"}, {
        "v": "140827",
        "n": "垣曲县"
      }, {"v": "140828", "n": "夏县"}, {"v": "140829", "n": "平陆县"}, {"v": "140830", "n": "芮城县"}, {
        "v": "140881",
        "n": "永济市"
      }, {"v": "140882", "n": "河津市"}]
    }, {
      "v": "140900",
      "n": "忻州市",
      "c": [{"v": "140902", "n": "忻府区"}, {"v": "140921", "n": "定襄县"}, {"v": "140922", "n": "五台县"}, {
        "v": "140923",
        "n": "代县"
      }, {"v": "140924", "n": "繁峙县"}, {"v": "140925", "n": "宁武县"}, {"v": "140926", "n": "静乐县"}, {
        "v": "140927",
        "n": "神池县"
      }, {"v": "140928", "n": "五寨县"}, {"v": "140929", "n": "岢岚县"}, {"v": "140930", "n": "河曲县"}, {
        "v": "140931",
        "n": "保德县"
      }, {"v": "140932", "n": "偏关县"}, {"v": "140981", "n": "原平市"}]
    }, {
      "v": "141000",
      "n": "临汾市",
      "c": [{"v": "141002", "n": "尧都区"}, {"v": "141021", "n": "曲沃县"}, {"v": "141022", "n": "翼城县"}, {
        "v": "141023",
        "n": "襄汾县"
      }, {"v": "141024", "n": "洪洞县"}, {"v": "141025", "n": "古县"}, {"v": "141026", "n": "安泽县"}, {
        "v": "141027",
        "n": "浮山县"
      }, {"v": "141028", "n": "吉县"}, {"v": "141029", "n": "乡宁县"}, {"v": "141030", "n": "大宁县"}, {
        "v": "141031",
        "n": "隰县"
      }, {"v": "141032", "n": "永和县"}, {"v": "141033", "n": "蒲县"}, {"v": "141034", "n": "汾西县"}, {
        "v": "141081",
        "n": "侯马市"
      }, {"v": "141082", "n": "霍州市"}]
    }, {
      "v": "141100",
      "n": "吕梁市",
      "c": [{"v": "141102", "n": "离石区"}, {"v": "141121", "n": "文水县"}, {"v": "141122", "n": "交城县"}, {
        "v": "141123",
        "n": "兴县"
      }, {"v": "141124", "n": "临县"}, {"v": "141125", "n": "柳林县"}, {"v": "141126", "n": "石楼县"}, {
        "v": "141127",
        "n": "岚县"
      }, {"v": "141128", "n": "方山县"}, {"v": "141129", "n": "中阳县"}, {"v": "141130", "n": "交口县"}, {
        "v": "141181",
        "n": "孝义市"
      }, {"v": "141182", "n": "汾阳市"}]
    }]
  }, {
    "v": "150000",
    "n": "内蒙古自治区",
    "c": [{
      "v": "150100",
      "n": "呼和浩特市",
      "c": [{"v": "150102", "n": "新城区"}, {"v": "150103", "n": "回民区"}, {"v": "150104", "n": "玉泉区"}, {
        "v": "150105",
        "n": "赛罕区"
      }, {"v": "150121", "n": "土默特左旗"}, {"v": "150122", "n": "托克托县"}, {"v": "150123", "n": "和林格尔县"}, {
        "v": "150124",
        "n": "清水河县"
      }, {"v": "150125", "n": "武川县"}]
    }, {
      "v": "150200",
      "n": "包头市",
      "c": [{"v": "150202", "n": "东河区"}, {"v": "150203", "n": "昆都仑区"}, {"v": "150204", "n": "青山区"}, {
        "v": "150205",
        "n": "石拐区"
      }, {"v": "150206", "n": "白云鄂博矿区"}, {"v": "150207", "n": "九原区"}, {"v": "150221", "n": "土默特右旗"}, {
        "v": "150222",
        "n": "固阳县"
      }, {"v": "150223", "n": "达尔罕茂明安联合旗"}]
    }, {
      "v": "150300",
      "n": "乌海市",
      "c": [{"v": "150302", "n": "海勃湾区"}, {"v": "150303", "n": "海南区"}, {"v": "150304", "n": "乌达区"}]
    }, {
      "v": "150400",
      "n": "赤峰市",
      "c": [{"v": "150402", "n": "红山区"}, {"v": "150403", "n": "元宝山区"}, {"v": "150404", "n": "松山区"}, {
        "v": "150421",
        "n": "阿鲁科尔沁旗"
      }, {"v": "150422", "n": "巴林左旗"}, {"v": "150423", "n": "巴林右旗"}, {"v": "150424", "n": "林西县"}, {
        "v": "150425",
        "n": "克什克腾旗"
      }, {"v": "150426", "n": "翁牛特旗"}, {"v": "150428", "n": "喀喇沁旗"}, {"v": "150429", "n": "宁城县"}, {
        "v": "150430",
        "n": "敖汉旗"
      }]
    }, {
      "v": "150500",
      "n": "通辽市",
      "c": [{"v": "150502", "n": "科尔沁区"}, {"v": "150521", "n": "科尔沁左翼中旗"}, {
        "v": "150522",
        "n": "科尔沁左翼后旗"
      }, {"v": "150523", "n": "开鲁县"}, {"v": "150524", "n": "库伦旗"}, {"v": "150525", "n": "奈曼旗"}, {
        "v": "150526",
        "n": "扎鲁特旗"
      }, {"v": "150581", "n": "霍林郭勒市"}]
    }, {
      "v": "150600",
      "n": "鄂尔多斯市",
      "c": [{"v": "150602", "n": "东胜区"}, {"v": "150603", "n": "康巴什区"}, {"v": "150621", "n": "达拉特旗"}, {
        "v": "150622",
        "n": "准格尔旗"
      }, {"v": "150623", "n": "鄂托克前旗"}, {"v": "150624", "n": "鄂托克旗"}, {"v": "150625", "n": "杭锦旗"}, {
        "v": "150626",
        "n": "乌审旗"
      }, {"v": "150627", "n": "伊金霍洛旗"}]
    }, {
      "v": "150700",
      "n": "呼伦贝尔市",
      "c": [{"v": "150702", "n": "海拉尔区"}, {"v": "150703", "n": "扎赉诺尔区"}, {"v": "150721", "n": "阿荣旗"}, {
        "v": "150722",
        "n": "莫力达瓦达斡尔族自治旗"
      }, {"v": "150723", "n": "鄂伦春自治旗"}, {"v": "150724", "n": "鄂温克族自治旗"}, {"v": "150725", "n": "陈巴尔虎旗"}, {
        "v": "150726",
        "n": "新巴尔虎左旗"
      }, {"v": "150727", "n": "新巴尔虎右旗"}, {"v": "150781", "n": "满洲里市"}, {"v": "150782", "n": "牙克石市"}, {
        "v": "150783",
        "n": "扎兰屯市"
      }, {"v": "150784", "n": "额尔古纳市"}, {"v": "150785", "n": "根河市"}]
    }, {
      "v": "150800",
      "n": "巴彦淖尔市",
      "c": [{"v": "150802", "n": "临河区"}, {"v": "150821", "n": "五原县"}, {"v": "150822", "n": "磴口县"}, {
        "v": "150823",
        "n": "乌拉特前旗"
      }, {"v": "150824", "n": "乌拉特中旗"}, {"v": "150825", "n": "乌拉特后旗"}, {"v": "150826", "n": "杭锦后旗"}]
    }, {
      "v": "150900",
      "n": "乌兰察布市",
      "c": [{"v": "150902", "n": "集宁区"}, {"v": "150921", "n": "卓资县"}, {"v": "150922", "n": "化德县"}, {
        "v": "150923",
        "n": "商都县"
      }, {"v": "150924", "n": "兴和县"}, {"v": "150925", "n": "凉城县"}, {"v": "150926", "n": "察哈尔右翼前旗"}, {
        "v": "150927",
        "n": "察哈尔右翼中旗"
      }, {"v": "150928", "n": "察哈尔右翼后旗"}, {"v": "150929", "n": "四子王旗"}, {"v": "150981", "n": "丰镇市"}]
    }, {
      "v": "152200",
      "n": "兴安盟",
      "c": [{"v": "152201", "n": "乌兰浩特市"}, {"v": "152202", "n": "阿尔山市"}, {
        "v": "152221",
        "n": "科尔沁右翼前旗"
      }, {"v": "152222", "n": "科尔沁右翼中旗"}, {"v": "152223", "n": "扎赉特旗"}, {"v": "152224", "n": "突泉县"}]
    }, {
      "v": "152500",
      "n": "锡林郭勒盟",
      "c": [{"v": "152501", "n": "二连浩特市"}, {"v": "152502", "n": "锡林浩特市"}, {"v": "152522", "n": "阿巴嘎旗"}, {
        "v": "152523",
        "n": "苏尼特左旗"
      }, {"v": "152524", "n": "苏尼特右旗"}, {"v": "152525", "n": "东乌珠穆沁旗"}, {"v": "152526", "n": "西乌珠穆沁旗"}, {
        "v": "152527",
        "n": "太仆寺旗"
      }, {"v": "152528", "n": "镶黄旗"}, {"v": "152529", "n": "正镶白旗"}, {"v": "152530", "n": "正蓝旗"}, {
        "v": "152531",
        "n": "多伦县"
      }]
    }, {
      "v": "152900",
      "n": "阿拉善盟",
      "c": [{"v": "152921", "n": "阿拉善左旗"}, {"v": "152922", "n": "阿拉善右旗"}, {"v": "152923", "n": "额济纳旗"}]
    }]
  }, {
    "v": "210000",
    "n": "辽宁省",
    "c": [{
      "v": "210100",
      "n": "沈阳市",
      "c": [{"v": "210102", "n": "和平区"}, {"v": "210103", "n": "沈河区"}, {"v": "210104", "n": "大东区"}, {
        "v": "210105",
        "n": "皇姑区"
      }, {"v": "210106", "n": "铁西区"}, {"v": "210111", "n": "苏家屯区"}, {"v": "210112", "n": "浑南区"}, {
        "v": "210113",
        "n": "沈北新区"
      }, {"v": "210114", "n": "于洪区"}, {"v": "210115", "n": "辽中区"}, {"v": "210123", "n": "康平县"}, {
        "v": "210124",
        "n": "法库县"
      }, {"v": "210181", "n": "新民市"}]
    }, {
      "v": "210200",
      "n": "大连市",
      "c": [{"v": "210202", "n": "中山区"}, {"v": "210203", "n": "西岗区"}, {"v": "210204", "n": "沙河口区"}, {
        "v": "210211",
        "n": "甘井子区"
      }, {"v": "210212", "n": "旅顺口区"}, {"v": "210213", "n": "金州区"}, {"v": "210214", "n": "普兰店区"}, {
        "v": "210224",
        "n": "长海县"
      }, {"v": "210281", "n": "瓦房店市"}, {"v": "210283", "n": "庄河市"}]
    }, {
      "v": "210300",
      "n": "鞍山市",
      "c": [{"v": "210302", "n": "铁东区"}, {"v": "210303", "n": "铁西区"}, {"v": "210304", "n": "立山区"}, {
        "v": "210311",
        "n": "千山区"
      }, {"v": "210321", "n": "台安县"}, {"v": "210323", "n": "岫岩满族自治县"}, {"v": "210381", "n": "海城市"}]
    }, {
      "v": "210400",
      "n": "抚顺市",
      "c": [{"v": "210402", "n": "新抚区"}, {"v": "210403", "n": "东洲区"}, {"v": "210404", "n": "望花区"}, {
        "v": "210411",
        "n": "顺城区"
      }, {"v": "210421", "n": "抚顺县"}, {"v": "210422", "n": "新宾满族自治县"}, {"v": "210423", "n": "清原满族自治县"}]
    }, {
      "v": "210500",
      "n": "本溪市",
      "c": [{"v": "210502", "n": "平山区"}, {"v": "210503", "n": "溪湖区"}, {"v": "210504", "n": "明山区"}, {
        "v": "210505",
        "n": "南芬区"
      }, {"v": "210521", "n": "本溪满族自治县"}, {"v": "210522", "n": "桓仁满族自治县"}]
    }, {
      "v": "210600",
      "n": "丹东市",
      "c": [{"v": "210602", "n": "元宝区"}, {"v": "210603", "n": "振兴区"}, {"v": "210604", "n": "振安区"}, {
        "v": "210624",
        "n": "宽甸满族自治县"
      }, {"v": "210681", "n": "东港市"}, {"v": "210682", "n": "凤城市"}]
    }, {
      "v": "210700",
      "n": "锦州市",
      "c": [{"v": "210702", "n": "古塔区"}, {"v": "210703", "n": "凌河区"}, {"v": "210711", "n": "太和区"}, {
        "v": "210726",
        "n": "黑山县"
      }, {"v": "210727", "n": "义县"}, {"v": "210781", "n": "凌海市"}, {"v": "210782", "n": "北镇市"}]
    }, {
      "v": "210800",
      "n": "营口市",
      "c": [{"v": "210802", "n": "站前区"}, {"v": "210803", "n": "西市区"}, {"v": "210804", "n": "鲅鱼圈区"}, {
        "v": "210811",
        "n": "老边区"
      }, {"v": "210881", "n": "盖州市"}, {"v": "210882", "n": "大石桥市"}]
    }, {
      "v": "210900",
      "n": "阜新市",
      "c": [{"v": "210902", "n": "海州区"}, {"v": "210903", "n": "新邱区"}, {"v": "210904", "n": "太平区"}, {
        "v": "210905",
        "n": "清河门区"
      }, {"v": "210911", "n": "细河区"}, {"v": "210921", "n": "阜新蒙古族自治县"}, {"v": "210922", "n": "彰武县"}]
    }, {
      "v": "211000",
      "n": "辽阳市",
      "c": [{"v": "211002", "n": "白塔区"}, {"v": "211003", "n": "文圣区"}, {"v": "211004", "n": "宏伟区"}, {
        "v": "211005",
        "n": "弓长岭区"
      }, {"v": "211011", "n": "太子河区"}, {"v": "211021", "n": "辽阳县"}, {"v": "211081", "n": "灯塔市"}]
    }, {
      "v": "211100",
      "n": "盘锦市",
      "c": [{"v": "211102", "n": "双台子区"}, {"v": "211103", "n": "兴隆台区"}, {"v": "211104", "n": "大洼区"}, {
        "v": "211122",
        "n": "盘山县"
      }]
    }, {
      "v": "211200",
      "n": "铁岭市",
      "c": [{"v": "211202", "n": "银州区"}, {"v": "211204", "n": "清河区"}, {"v": "211221", "n": "铁岭县"}, {
        "v": "211223",
        "n": "西丰县"
      }, {"v": "211224", "n": "昌图县"}, {"v": "211281", "n": "调兵山市"}, {"v": "211282", "n": "开原市"}]
    }, {
      "v": "211300",
      "n": "朝阳市",
      "c": [{"v": "211302", "n": "双塔区"}, {"v": "211303", "n": "龙城区"}, {"v": "211321", "n": "朝阳县"}, {
        "v": "211322",
        "n": "建平县"
      }, {"v": "211324", "n": "喀喇沁左翼蒙古族自治县"}, {"v": "211381", "n": "北票市"}, {"v": "211382", "n": "凌源市"}]
    }, {
      "v": "211400",
      "n": "葫芦岛市",
      "c": [{"v": "211402", "n": "连山区"}, {"v": "211403", "n": "龙港区"}, {"v": "211404", "n": "南票区"}, {
        "v": "211421",
        "n": "绥中县"
      }, {"v": "211422", "n": "建昌县"}, {"v": "211481", "n": "兴城市"}]
    }]
  }, {
    "v": "220000",
    "n": "吉林省",
    "c": [{
      "v": "220100",
      "n": "长春市",
      "c": [{"v": "220102", "n": "南关区"}, {"v": "220103", "n": "宽城区"}, {"v": "220104", "n": "朝阳区"}, {
        "v": "220105",
        "n": "二道区"
      }, {"v": "220106", "n": "绿园区"}, {"v": "220112", "n": "双阳区"}, {"v": "220113", "n": "九台区"}, {
        "v": "220122",
        "n": "农安县"
      }, {"v": "220182", "n": "榆树市"}, {"v": "220183", "n": "德惠市"}]
    }, {
      "v": "220200",
      "n": "吉林市",
      "c": [{"v": "220202", "n": "昌邑区"}, {"v": "220203", "n": "龙潭区"}, {"v": "220204", "n": "船营区"}, {
        "v": "220211",
        "n": "丰满区"
      }, {"v": "220221", "n": "永吉县"}, {"v": "220281", "n": "蛟河市"}, {"v": "220282", "n": "桦甸市"}, {
        "v": "220283",
        "n": "舒兰市"
      }, {"v": "220284", "n": "磐石市"}]
    }, {
      "v": "220300",
      "n": "四平市",
      "c": [{"v": "220302", "n": "铁西区"}, {"v": "220303", "n": "铁东区"}, {"v": "220322", "n": "梨树县"}, {
        "v": "220323",
        "n": "伊通满族自治县"
      }, {"v": "220381", "n": "公主岭市"}, {"v": "220382", "n": "双辽市"}]
    }, {
      "v": "220400",
      "n": "辽源市",
      "c": [{"v": "220402", "n": "龙山区"}, {"v": "220403", "n": "西安区"}, {"v": "220421", "n": "东丰县"}, {
        "v": "220422",
        "n": "东辽县"
      }]
    }, {
      "v": "220500",
      "n": "通化市",
      "c": [{"v": "220502", "n": "东昌区"}, {"v": "220503", "n": "二道江区"}, {"v": "220521", "n": "通化县"}, {
        "v": "220523",
        "n": "辉南县"
      }, {"v": "220524", "n": "柳河县"}, {"v": "220581", "n": "梅河口市"}, {"v": "220582", "n": "集安市"}]
    }, {
      "v": "220600",
      "n": "白山市",
      "c": [{"v": "220602", "n": "浑江区"}, {"v": "220605", "n": "江源区"}, {"v": "220621", "n": "抚松县"}, {
        "v": "220622",
        "n": "靖宇县"
      }, {"v": "220623", "n": "长白朝鲜族自治县"}, {"v": "220681", "n": "临江市"}]
    }, {
      "v": "220700",
      "n": "松原市",
      "c": [{"v": "220702", "n": "宁江区"}, {"v": "220721", "n": "前郭尔罗斯蒙古族自治县"}, {
        "v": "220722",
        "n": "长岭县"
      }, {"v": "220723", "n": "乾安县"}, {"v": "220781", "n": "扶余市"}]
    }, {
      "v": "220800",
      "n": "白城市",
      "c": [{"v": "220802", "n": "洮北区"}, {"v": "220821", "n": "镇赉县"}, {"v": "220822", "n": "通榆县"}, {
        "v": "220881",
        "n": "洮南市"
      }, {"v": "220882", "n": "大安市"}]
    }, {
      "v": "222400",
      "n": "延边朝鲜族自治州",
      "c": [{"v": "222401", "n": "延吉市"}, {"v": "222402", "n": "图们市"}, {"v": "222403", "n": "敦化市"}, {
        "v": "222404",
        "n": "珲春市"
      }, {"v": "222405", "n": "龙井市"}, {"v": "222406", "n": "和龙市"}, {"v": "222424", "n": "汪清县"}, {
        "v": "222426",
        "n": "安图县"
      }]
    }]
  }, {
    "v": "230000",
    "n": "黑龙江省",
    "c": [{
      "v": "230100",
      "n": "哈尔滨市",
      "c": [{"v": "230102", "n": "道里区"}, {"v": "230103", "n": "南岗区"}, {"v": "230104", "n": "道外区"}, {
        "v": "230108",
        "n": "平房区"
      }, {"v": "230109", "n": "松北区"}, {"v": "230110", "n": "香坊区"}, {"v": "230111", "n": "呼兰区"}, {
        "v": "230112",
        "n": "阿城区"
      }, {"v": "230113", "n": "双城区"}, {"v": "230123", "n": "依兰县"}, {"v": "230124", "n": "方正县"}, {
        "v": "230125",
        "n": "宾县"
      }, {"v": "230126", "n": "巴彦县"}, {"v": "230127", "n": "木兰县"}, {"v": "230128", "n": "通河县"}, {
        "v": "230129",
        "n": "延寿县"
      }, {"v": "230183", "n": "尚志市"}, {"v": "230184", "n": "五常市"}]
    }, {
      "v": "230200",
      "n": "齐齐哈尔市",
      "c": [{"v": "230202", "n": "龙沙区"}, {"v": "230203", "n": "建华区"}, {"v": "230204", "n": "铁锋区"}, {
        "v": "230205",
        "n": "昂昂溪区"
      }, {"v": "230206", "n": "富拉尔基区"}, {"v": "230207", "n": "碾子山区"}, {"v": "230208", "n": "梅里斯达斡尔族区"}, {
        "v": "230221",
        "n": "龙江县"
      }, {"v": "230223", "n": "依安县"}, {"v": "230224", "n": "泰来县"}, {"v": "230225", "n": "甘南县"}, {
        "v": "230227",
        "n": "富裕县"
      }, {"v": "230229", "n": "克山县"}, {"v": "230230", "n": "克东县"}, {"v": "230231", "n": "拜泉县"}, {
        "v": "230281",
        "n": "讷河市"
      }]
    }, {
      "v": "230300",
      "n": "鸡西市",
      "c": [{"v": "230302", "n": "鸡冠区"}, {"v": "230303", "n": "恒山区"}, {"v": "230304", "n": "滴道区"}, {
        "v": "230305",
        "n": "梨树区"
      }, {"v": "230306", "n": "城子河区"}, {"v": "230307", "n": "麻山区"}, {"v": "230321", "n": "鸡东县"}, {
        "v": "230381",
        "n": "虎林市"
      }, {"v": "230382", "n": "密山市"}]
    }, {
      "v": "230400",
      "n": "鹤岗市",
      "c": [{"v": "230402", "n": "向阳区"}, {"v": "230403", "n": "工农区"}, {"v": "230404", "n": "南山区"}, {
        "v": "230405",
        "n": "兴安区"
      }, {"v": "230406", "n": "东山区"}, {"v": "230407", "n": "兴山区"}, {"v": "230421", "n": "萝北县"}, {
        "v": "230422",
        "n": "绥滨县"
      }]
    }, {
      "v": "230500",
      "n": "双鸭山市",
      "c": [{"v": "230502", "n": "尖山区"}, {"v": "230503", "n": "岭东区"}, {"v": "230505", "n": "四方台区"}, {
        "v": "230506",
        "n": "宝山区"
      }, {"v": "230521", "n": "集贤县"}, {"v": "230522", "n": "友谊县"}, {"v": "230523", "n": "宝清县"}, {
        "v": "230524",
        "n": "饶河县"
      }]
    }, {
      "v": "230600",
      "n": "大庆市",
      "c": [{"v": "230602", "n": "萨尔图区"}, {"v": "230603", "n": "龙凤区"}, {"v": "230604", "n": "让胡路区"}, {
        "v": "230605",
        "n": "红岗区"
      }, {"v": "230606", "n": "大同区"}, {"v": "230621", "n": "肇州县"}, {"v": "230622", "n": "肇源县"}, {
        "v": "230623",
        "n": "林甸县"
      }, {"v": "230624", "n": "杜尔伯特蒙古族自治县"}]
    }, {
      "v": "230700",
      "n": "伊春市",
      "c": [{"v": "230717", "n": "伊美区"}, {"v": "230718", "n": "乌翠区"}, {"v": "230719", "n": "友好区"}, {
        "v": "230722",
        "n": "嘉荫县"
      }, {"v": "230723", "n": "汤旺县"}, {"v": "230724", "n": "丰林县"}, {"v": "230725", "n": "大箐山县"}, {
        "v": "230726",
        "n": "南岔县"
      }, {"v": "230751", "n": "金林区"}, {"v": "230781", "n": "铁力市"}]
    }, {
      "v": "230800",
      "n": "佳木斯市",
      "c": [{"v": "230803", "n": "向阳区"}, {"v": "230804", "n": "前进区"}, {"v": "230805", "n": "东风区"}, {
        "v": "230811",
        "n": "郊区"
      }, {"v": "230822", "n": "桦南县"}, {"v": "230826", "n": "桦川县"}, {"v": "230828", "n": "汤原县"}, {
        "v": "230881",
        "n": "同江市"
      }, {"v": "230882", "n": "富锦市"}, {"v": "230883", "n": "抚远市"}]
    }, {
      "v": "230900",
      "n": "七台河市",
      "c": [{"v": "230902", "n": "新兴区"}, {"v": "230903", "n": "桃山区"}, {"v": "230904", "n": "茄子河区"}, {
        "v": "230921",
        "n": "勃利县"
      }]
    }, {
      "v": "231000",
      "n": "牡丹江市",
      "c": [{"v": "231002", "n": "东安区"}, {"v": "231003", "n": "阳明区"}, {"v": "231004", "n": "爱民区"}, {
        "v": "231005",
        "n": "西安区"
      }, {"v": "231025", "n": "林口县"}, {"v": "231081", "n": "绥芬河市"}, {"v": "231083", "n": "海林市"}, {
        "v": "231084",
        "n": "宁安市"
      }, {"v": "231085", "n": "穆棱市"}, {"v": "231086", "n": "东宁市"}]
    }, {
      "v": "231100",
      "n": "黑河市",
      "c": [{"v": "231102", "n": "爱辉区"}, {"v": "231123", "n": "逊克县"}, {"v": "231124", "n": "孙吴县"}, {
        "v": "231181",
        "n": "北安市"
      }, {"v": "231182", "n": "五大连池市"}, {"v": "231183", "n": "嫩江市"}]
    }, {
      "v": "231200",
      "n": "绥化市",
      "c": [{"v": "231202", "n": "北林区"}, {"v": "231221", "n": "望奎县"}, {"v": "231222", "n": "兰西县"}, {
        "v": "231223",
        "n": "青冈县"
      }, {"v": "231224", "n": "庆安县"}, {"v": "231225", "n": "明水县"}, {"v": "231226", "n": "绥棱县"}, {
        "v": "231281",
        "n": "安达市"
      }, {"v": "231282", "n": "肇东市"}, {"v": "231283", "n": "海伦市"}]
    }, {
      "v": "232700",
      "n": "大兴安岭地区",
      "c": [{"v": "232701", "n": "漠河市"}, {"v": "232721", "n": "呼玛县"}, {"v": "232722", "n": "塔河县"}]
    }]
  }, {
    "v": "310000",
    "n": "上海市",
    "c": [{
      "v": "310100",
      "n": "上海市",
      "c": [{"v": "310101", "n": "黄浦区"}, {"v": "310104", "n": "徐汇区"}, {"v": "310105", "n": "长宁区"}, {
        "v": "310106",
        "n": "静安区"
      }, {"v": "310107", "n": "普陀区"}, {"v": "310109", "n": "虹口区"}, {"v": "310110", "n": "杨浦区"}, {
        "v": "310112",
        "n": "闵行区"
      }, {"v": "310113", "n": "宝山区"}, {"v": "310114", "n": "嘉定区"}, {"v": "310115", "n": "浦东新区"}, {
        "v": "310116",
        "n": "金山区"
      }, {"v": "310117", "n": "松江区"}, {"v": "310118", "n": "青浦区"}, {"v": "310120", "n": "奉贤区"}, {
        "v": "310151",
        "n": "崇明区"
      }]
    }]
  }, {
    "v": "320000",
    "n": "江苏省",
    "c": [{
      "v": "320100",
      "n": "南京市",
      "c": [{"v": "320102", "n": "玄武区"}, {"v": "320104", "n": "秦淮区"}, {"v": "320105", "n": "建邺区"}, {
        "v": "320106",
        "n": "鼓楼区"
      }, {"v": "320111", "n": "浦口区"}, {"v": "320113", "n": "栖霞区"}, {"v": "320114", "n": "雨花台区"}, {
        "v": "320115",
        "n": "江宁区"
      }, {"v": "320116", "n": "六合区"}, {"v": "320117", "n": "溧水区"}, {"v": "320118", "n": "高淳区"}]
    }, {
      "v": "320200",
      "n": "无锡市",
      "c": [{"v": "320205", "n": "锡山区"}, {"v": "320206", "n": "惠山区"}, {"v": "320211", "n": "滨湖区"}, {
        "v": "320213",
        "n": "梁溪区"
      }, {"v": "320214", "n": "新吴区"}, {"v": "320281", "n": "江阴市"}, {"v": "320282", "n": "宜兴市"}]
    }, {
      "v": "320300",
      "n": "徐州市",
      "c": [{"v": "320302", "n": "鼓楼区"}, {"v": "320303", "n": "云龙区"}, {"v": "320305", "n": "贾汪区"}, {
        "v": "320311",
        "n": "泉山区"
      }, {"v": "320312", "n": "铜山区"}, {"v": "320321", "n": "丰县"}, {"v": "320322", "n": "沛县"}, {
        "v": "320324",
        "n": "睢宁县"
      }, {"v": "320381", "n": "新沂市"}, {"v": "320382", "n": "邳州市"}]
    }, {
      "v": "320400",
      "n": "常州市",
      "c": [{"v": "320402", "n": "天宁区"}, {"v": "320404", "n": "钟楼区"}, {"v": "320411", "n": "新北区"}, {
        "v": "320412",
        "n": "武进区"
      }, {"v": "320413", "n": "金坛区"}, {"v": "320481", "n": "溧阳市"}]
    }, {
      "v": "320500",
      "n": "苏州市",
      "c": [{"v": "320505", "n": "虎丘区"}, {"v": "320506", "n": "吴中区"}, {"v": "320507", "n": "相城区"}, {
        "v": "320508",
        "n": "姑苏区"
      }, {"v": "320509", "n": "吴江区"}, {"v": "320581", "n": "常熟市"}, {"v": "320582", "n": "张家港市"}, {
        "v": "320583",
        "n": "昆山市"
      }, {"v": "320585", "n": "太仓市"}]
    }, {
      "v": "320600",
      "n": "南通市",
      "c": [{"v": "320602", "n": "崇川区"}, {"v": "320611", "n": "港闸区"}, {"v": "320612", "n": "通州区"}, {
        "v": "320623",
        "n": "如东县"
      }, {"v": "320681", "n": "启东市"}, {"v": "320682", "n": "如皋市"}, {"v": "320684", "n": "海门市"}, {
        "v": "320685",
        "n": "海安市"
      }]
    }, {
      "v": "320700",
      "n": "连云港市",
      "c": [{"v": "320703", "n": "连云区"}, {"v": "320706", "n": "海州区"}, {"v": "320707", "n": "赣榆区"}, {
        "v": "320722",
        "n": "东海县"
      }, {"v": "320723", "n": "灌云县"}, {"v": "320724", "n": "灌南县"}]
    }, {
      "v": "320800",
      "n": "淮安市",
      "c": [{"v": "320803", "n": "淮安区"}, {"v": "320804", "n": "淮阴区"}, {"v": "320812", "n": "清江浦区"}, {
        "v": "320813",
        "n": "洪泽区"
      }, {"v": "320826", "n": "涟水县"}, {"v": "320830", "n": "盱眙县"}, {"v": "320831", "n": "金湖县"}]
    }, {
      "v": "320900",
      "n": "盐城市",
      "c": [{"v": "320902", "n": "亭湖区"}, {"v": "320903", "n": "盐都区"}, {"v": "320904", "n": "大丰区"}, {
        "v": "320921",
        "n": "响水县"
      }, {"v": "320922", "n": "滨海县"}, {"v": "320923", "n": "阜宁县"}, {"v": "320924", "n": "射阳县"}, {
        "v": "320925",
        "n": "建湖县"
      }, {"v": "320981", "n": "东台市"}]
    }, {
      "v": "321000",
      "n": "扬州市",
      "c": [{"v": "321002", "n": "广陵区"}, {"v": "321003", "n": "邗江区"}, {"v": "321012", "n": "江都区"}, {
        "v": "321023",
        "n": "宝应县"
      }, {"v": "321081", "n": "仪征市"}, {"v": "321084", "n": "高邮市"}]
    }, {
      "v": "321100",
      "n": "镇江市",
      "c": [{"v": "321102", "n": "京口区"}, {"v": "321111", "n": "润州区"}, {"v": "321112", "n": "丹徒区"}, {
        "v": "321181",
        "n": "丹阳市"
      }, {"v": "321182", "n": "扬中市"}, {"v": "321183", "n": "句容市"}]
    }, {
      "v": "321200",
      "n": "泰州市",
      "c": [{"v": "321202", "n": "海陵区"}, {"v": "321203", "n": "高港区"}, {"v": "321204", "n": "姜堰区"}, {
        "v": "321281",
        "n": "兴化市"
      }, {"v": "321282", "n": "靖江市"}, {"v": "321283", "n": "泰兴市"}]
    }, {
      "v": "321300",
      "n": "宿迁市",
      "c": [{"v": "321302", "n": "宿城区"}, {"v": "321311", "n": "宿豫区"}, {"v": "321322", "n": "沭阳县"}, {
        "v": "321323",
        "n": "泗阳县"
      }, {"v": "321324", "n": "泗洪县"}]
    }]
  }, {
    "v": "330000",
    "n": "浙江省",
    "c": [{
      "v": "330100",
      "n": "杭州市",
      "c": [{"v": "330102", "n": "上城区"}, {"v": "330103", "n": "下城区"}, {"v": "330104", "n": "江干区"}, {
        "v": "330105",
        "n": "拱墅区"
      }, {"v": "330106", "n": "西湖区"}, {"v": "330108", "n": "滨江区"}, {"v": "330109", "n": "萧山区"}, {
        "v": "330110",
        "n": "余杭区"
      }, {"v": "330111", "n": "富阳区"}, {"v": "330112", "n": "临安区"}, {"v": "330122", "n": "桐庐县"}, {
        "v": "330127",
        "n": "淳安县"
      }, {"v": "330182", "n": "建德市"}]
    }, {
      "v": "330200",
      "n": "宁波市",
      "c": [{"v": "330203", "n": "海曙区"}, {"v": "330205", "n": "江北区"}, {"v": "330206", "n": "北仑区"}, {
        "v": "330211",
        "n": "镇海区"
      }, {"v": "330212", "n": "鄞州区"}, {"v": "330213", "n": "奉化区"}, {"v": "330225", "n": "象山县"}, {
        "v": "330226",
        "n": "宁海县"
      }, {"v": "330281", "n": "余姚市"}, {"v": "330282", "n": "慈溪市"}]
    }, {
      "v": "330300",
      "n": "温州市",
      "c": [{"v": "330302", "n": "鹿城区"}, {"v": "330303", "n": "龙湾区"}, {"v": "330304", "n": "瓯海区"}, {
        "v": "330305",
        "n": "洞头区"
      }, {"v": "330324", "n": "永嘉县"}, {"v": "330326", "n": "平阳县"}, {"v": "330327", "n": "苍南县"}, {
        "v": "330328",
        "n": "文成县"
      }, {"v": "330329", "n": "泰顺县"}, {"v": "330381", "n": "瑞安市"}, {"v": "330382", "n": "乐清市"}, {
        "v": "330383",
        "n": "龙港市"
      }]
    }, {
      "v": "330400",
      "n": "嘉兴市",
      "c": [{"v": "330402", "n": "南湖区"}, {"v": "330411", "n": "秀洲区"}, {"v": "330421", "n": "嘉善县"}, {
        "v": "330424",
        "n": "海盐县"
      }, {"v": "330481", "n": "海宁市"}, {"v": "330482", "n": "平湖市"}, {"v": "330483", "n": "桐乡市"}]
    }, {
      "v": "330500",
      "n": "湖州市",
      "c": [{"v": "330502", "n": "吴兴区"}, {"v": "330503", "n": "南浔区"}, {"v": "330521", "n": "德清县"}, {
        "v": "330522",
        "n": "长兴县"
      }, {"v": "330523", "n": "安吉县"}]
    }, {
      "v": "330600",
      "n": "绍兴市",
      "c": [{"v": "330602", "n": "越城区"}, {"v": "330603", "n": "柯桥区"}, {"v": "330604", "n": "上虞区"}, {
        "v": "330624",
        "n": "新昌县"
      }, {"v": "330681", "n": "诸暨市"}, {"v": "330683", "n": "嵊州市"}]
    }, {
      "v": "330700",
      "n": "金华市",
      "c": [{"v": "330702", "n": "婺城区"}, {"v": "330703", "n": "金东区"}, {"v": "330723", "n": "武义县"}, {
        "v": "330726",
        "n": "浦江县"
      }, {"v": "330727", "n": "磐安县"}, {"v": "330781", "n": "兰溪市"}, {"v": "330782", "n": "义乌市"}, {
        "v": "330783",
        "n": "东阳市"
      }, {"v": "330784", "n": "永康市"}]
    }, {
      "v": "330800",
      "n": "衢州市",
      "c": [{"v": "330802", "n": "柯城区"}, {"v": "330803", "n": "衢江区"}, {"v": "330822", "n": "常山县"}, {
        "v": "330824",
        "n": "开化县"
      }, {"v": "330825", "n": "龙游县"}, {"v": "330881", "n": "江山市"}]
    }, {
      "v": "330900",
      "n": "舟山市",
      "c": [{"v": "330902", "n": "定海区"}, {"v": "330903", "n": "普陀区"}, {"v": "330921", "n": "岱山县"}, {
        "v": "330922",
        "n": "嵊泗县"
      }]
    }, {
      "v": "331000",
      "n": "台州市",
      "c": [{"v": "331002", "n": "椒江区"}, {"v": "331003", "n": "黄岩区"}, {"v": "331004", "n": "路桥区"}, {
        "v": "331022",
        "n": "三门县"
      }, {"v": "331023", "n": "天台县"}, {"v": "331024", "n": "仙居县"}, {"v": "331081", "n": "温岭市"}, {
        "v": "331082",
        "n": "临海市"
      }, {"v": "331083", "n": "玉环市"}]
    }, {
      "v": "331100",
      "n": "丽水市",
      "c": [{"v": "331102", "n": "莲都区"}, {"v": "331121", "n": "青田县"}, {"v": "331122", "n": "缙云县"}, {
        "v": "331123",
        "n": "遂昌县"
      }, {"v": "331124", "n": "松阳县"}, {"v": "331125", "n": "云和县"}, {"v": "331126", "n": "庆元县"}, {
        "v": "331127",
        "n": "景宁畲族自治县"
      }, {"v": "331181", "n": "龙泉市"}]
    }]
  }, {
    "v": "340000",
    "n": "安徽省",
    "c": [{
      "v": "340100",
      "n": "合肥市",
      "c": [{"v": "340102", "n": "瑶海区"}, {"v": "340103", "n": "庐阳区"}, {"v": "340104", "n": "蜀山区"}, {
        "v": "340111",
        "n": "包河区"
      }, {"v": "340121", "n": "长丰县"}, {"v": "340122", "n": "肥东县"}, {"v": "340123", "n": "肥西县"}, {
        "v": "340124",
        "n": "庐江县"
      }, {"v": "340181", "n": "巢湖市"}]
    }, {
      "v": "340200",
      "n": "芜湖市",
      "c": [{"v": "340202", "n": "镜湖区"}, {"v": "340203", "n": "弋江区"}, {"v": "340207", "n": "鸠江区"}, {
        "v": "340208",
        "n": "三山区"
      }, {"v": "340221", "n": "芜湖县"}, {"v": "340222", "n": "繁昌县"}, {"v": "340223", "n": "南陵县"}, {
        "v": "340281",
        "n": "无为市"
      }]
    }, {
      "v": "340300",
      "n": "蚌埠市",
      "c": [{"v": "340302", "n": "龙子湖区"}, {"v": "340303", "n": "蚌山区"}, {"v": "340304", "n": "禹会区"}, {
        "v": "340311",
        "n": "淮上区"
      }, {"v": "340321", "n": "怀远县"}, {"v": "340322", "n": "五河县"}, {"v": "340323", "n": "固镇县"}]
    }, {
      "v": "340400",
      "n": "淮南市",
      "c": [{"v": "340402", "n": "大通区"}, {"v": "340403", "n": "田家庵区"}, {"v": "340404", "n": "谢家集区"}, {
        "v": "340405",
        "n": "八公山区"
      }, {"v": "340406", "n": "潘集区"}, {"v": "340421", "n": "凤台县"}, {"v": "340422", "n": "寿县"}]
    }, {
      "v": "340500",
      "n": "马鞍山市",
      "c": [{"v": "340503", "n": "花山区"}, {"v": "340504", "n": "雨山区"}, {"v": "340506", "n": "博望区"}, {
        "v": "340521",
        "n": "当涂县"
      }, {"v": "340522", "n": "含山县"}, {"v": "340523", "n": "和县"}]
    }, {
      "v": "340600",
      "n": "淮北市",
      "c": [{"v": "340602", "n": "杜集区"}, {"v": "340603", "n": "相山区"}, {"v": "340604", "n": "烈山区"}, {
        "v": "340621",
        "n": "濉溪县"
      }]
    }, {
      "v": "340700",
      "n": "铜陵市",
      "c": [{"v": "340705", "n": "铜官区"}, {"v": "340706", "n": "义安区"}, {"v": "340711", "n": "郊区"}, {
        "v": "340722",
        "n": "枞阳县"
      }]
    }, {
      "v": "340800",
      "n": "安庆市",
      "c": [{"v": "340802", "n": "迎江区"}, {"v": "340803", "n": "大观区"}, {"v": "340811", "n": "宜秀区"}, {
        "v": "340822",
        "n": "怀宁县"
      }, {"v": "340825", "n": "太湖县"}, {"v": "340826", "n": "宿松县"}, {"v": "340827", "n": "望江县"}, {
        "v": "340828",
        "n": "岳西县"
      }, {"v": "340881", "n": "桐城市"}, {"v": "340882", "n": "潜山市"}]
    }, {
      "v": "341000",
      "n": "黄山市",
      "c": [{"v": "341002", "n": "屯溪区"}, {"v": "341003", "n": "黄山区"}, {"v": "341004", "n": "徽州区"}, {
        "v": "341021",
        "n": "歙县"
      }, {"v": "341022", "n": "休宁县"}, {"v": "341023", "n": "黟县"}, {"v": "341024", "n": "祁门县"}]
    }, {
      "v": "341100",
      "n": "滁州市",
      "c": [{"v": "341102", "n": "琅琊区"}, {"v": "341103", "n": "南谯区"}, {"v": "341122", "n": "来安县"}, {
        "v": "341124",
        "n": "全椒县"
      }, {"v": "341125", "n": "定远县"}, {"v": "341126", "n": "凤阳县"}, {"v": "341181", "n": "天长市"}, {
        "v": "341182",
        "n": "明光市"
      }]
    }, {
      "v": "341200",
      "n": "阜阳市",
      "c": [{"v": "341202", "n": "颍州区"}, {"v": "341203", "n": "颍东区"}, {"v": "341204", "n": "颍泉区"}, {
        "v": "341221",
        "n": "临泉县"
      }, {"v": "341222", "n": "太和县"}, {"v": "341225", "n": "阜南县"}, {"v": "341226", "n": "颍上县"}, {
        "v": "341282",
        "n": "界首市"
      }]
    }, {
      "v": "341300",
      "n": "宿州市",
      "c": [{"v": "341302", "n": "埇桥区"}, {"v": "341321", "n": "砀山县"}, {"v": "341322", "n": "萧县"}, {
        "v": "341323",
        "n": "灵璧县"
      }, {"v": "341324", "n": "泗县"}]
    }, {
      "v": "341500",
      "n": "六安市",
      "c": [{"v": "341502", "n": "金安区"}, {"v": "341503", "n": "裕安区"}, {"v": "341504", "n": "叶集区"}, {
        "v": "341522",
        "n": "霍邱县"
      }, {"v": "341523", "n": "舒城县"}, {"v": "341524", "n": "金寨县"}, {"v": "341525", "n": "霍山县"}]
    }, {
      "v": "341600",
      "n": "亳州市",
      "c": [{"v": "341602", "n": "谯城区"}, {"v": "341621", "n": "涡阳县"}, {"v": "341622", "n": "蒙城县"}, {
        "v": "341623",
        "n": "利辛县"
      }]
    }, {
      "v": "341700",
      "n": "池州市",
      "c": [{"v": "341702", "n": "贵池区"}, {"v": "341721", "n": "东至县"}, {"v": "341722", "n": "石台县"}, {
        "v": "341723",
        "n": "青阳县"
      }]
    }, {
      "v": "341800",
      "n": "宣城市",
      "c": [{"v": "341802", "n": "宣州区"}, {"v": "341821", "n": "郎溪县"}, {"v": "341823", "n": "泾县"}, {
        "v": "341824",
        "n": "绩溪县"
      }, {"v": "341825", "n": "旌德县"}, {"v": "341881", "n": "宁国市"}, {"v": "341882", "n": "广德市"}]
    }]
  }, {
    "v": "350000",
    "n": "福建省",
    "c": [{
      "v": "350100",
      "n": "福州市",
      "c": [{"v": "350102", "n": "鼓楼区"}, {"v": "350103", "n": "台江区"}, {"v": "350104", "n": "仓山区"}, {
        "v": "350105",
        "n": "马尾区"
      }, {"v": "350111", "n": "晋安区"}, {"v": "350112", "n": "长乐区"}, {"v": "350121", "n": "闽侯县"}, {
        "v": "350122",
        "n": "连江县"
      }, {"v": "350123", "n": "罗源县"}, {"v": "350124", "n": "闽清县"}, {"v": "350125", "n": "永泰县"}, {
        "v": "350128",
        "n": "平潭县"
      }, {"v": "350181", "n": "福清市"}]
    }, {
      "v": "350200",
      "n": "厦门市",
      "c": [{"v": "350203", "n": "思明区"}, {"v": "350205", "n": "海沧区"}, {"v": "350206", "n": "湖里区"}, {
        "v": "350211",
        "n": "集美区"
      }, {"v": "350212", "n": "同安区"}, {"v": "350213", "n": "翔安区"}]
    }, {
      "v": "350300",
      "n": "莆田市",
      "c": [{"v": "350302", "n": "城厢区"}, {"v": "350303", "n": "涵江区"}, {"v": "350304", "n": "荔城区"}, {
        "v": "350305",
        "n": "秀屿区"
      }, {"v": "350322", "n": "仙游县"}]
    }, {
      "v": "350400",
      "n": "三明市",
      "c": [{"v": "350402", "n": "梅列区"}, {"v": "350403", "n": "三元区"}, {"v": "350421", "n": "明溪县"}, {
        "v": "350423",
        "n": "清流县"
      }, {"v": "350424", "n": "宁化县"}, {"v": "350425", "n": "大田县"}, {"v": "350426", "n": "尤溪县"}, {
        "v": "350427",
        "n": "沙县"
      }, {"v": "350428", "n": "将乐县"}, {"v": "350429", "n": "泰宁县"}, {"v": "350430", "n": "建宁县"}, {
        "v": "350481",
        "n": "永安市"
      }]
    }, {
      "v": "350500",
      "n": "泉州市",
      "c": [{"v": "350502", "n": "鲤城区"}, {"v": "350503", "n": "丰泽区"}, {"v": "350504", "n": "洛江区"}, {
        "v": "350505",
        "n": "泉港区"
      }, {"v": "350521", "n": "惠安县"}, {"v": "350524", "n": "安溪县"}, {"v": "350525", "n": "永春县"}, {
        "v": "350526",
        "n": "德化县"
      }, {"v": "350527", "n": "金门县"}, {"v": "350581", "n": "石狮市"}, {"v": "350582", "n": "晋江市"}, {
        "v": "350583",
        "n": "南安市"
      }]
    }, {
      "v": "350600",
      "n": "漳州市",
      "c": [{"v": "350602", "n": "芗城区"}, {"v": "350603", "n": "龙文区"}, {"v": "350622", "n": "云霄县"}, {
        "v": "350623",
        "n": "漳浦县"
      }, {"v": "350624", "n": "诏安县"}, {"v": "350625", "n": "长泰县"}, {"v": "350626", "n": "东山县"}, {
        "v": "350627",
        "n": "南靖县"
      }, {"v": "350628", "n": "平和县"}, {"v": "350629", "n": "华安县"}, {"v": "350681", "n": "龙海市"}]
    }, {
      "v": "350700",
      "n": "南平市",
      "c": [{"v": "350702", "n": "延平区"}, {"v": "350703", "n": "建阳区"}, {"v": "350721", "n": "顺昌县"}, {
        "v": "350722",
        "n": "浦城县"
      }, {"v": "350723", "n": "光泽县"}, {"v": "350724", "n": "松溪县"}, {"v": "350725", "n": "政和县"}, {
        "v": "350781",
        "n": "邵武市"
      }, {"v": "350782", "n": "武夷山市"}, {"v": "350783", "n": "建瓯市"}]
    }, {
      "v": "350800",
      "n": "龙岩市",
      "c": [{"v": "350802", "n": "新罗区"}, {"v": "350803", "n": "永定区"}, {"v": "350821", "n": "长汀县"}, {
        "v": "350823",
        "n": "上杭县"
      }, {"v": "350824", "n": "武平县"}, {"v": "350825", "n": "连城县"}, {"v": "350881", "n": "漳平市"}]
    }, {
      "v": "350900",
      "n": "宁德市",
      "c": [{"v": "350902", "n": "蕉城区"}, {"v": "350921", "n": "霞浦县"}, {"v": "350922", "n": "古田县"}, {
        "v": "350923",
        "n": "屏南县"
      }, {"v": "350924", "n": "寿宁县"}, {"v": "350925", "n": "周宁县"}, {"v": "350926", "n": "柘荣县"}, {
        "v": "350981",
        "n": "福安市"
      }, {"v": "350982", "n": "福鼎市"}]
    }]
  }, {
    "v": "360000",
    "n": "江西省",
    "c": [{
      "v": "360100",
      "n": "南昌市",
      "c": [{"v": "360102", "n": "东湖区"}, {"v": "360103", "n": "西湖区"}, {"v": "360104", "n": "青云谱区"}, {
        "v": "360111",
        "n": "青山湖区"
      }, {"v": "360112", "n": "新建区"}, {"v": "360113", "n": "红谷滩区"}, {"v": "360121", "n": "南昌县"}, {
        "v": "360123",
        "n": "安义县"
      }, {"v": "360124", "n": "进贤县"}]
    }, {
      "v": "360200",
      "n": "景德镇市",
      "c": [{"v": "360202", "n": "昌江区"}, {"v": "360203", "n": "珠山区"}, {"v": "360222", "n": "浮梁县"}, {
        "v": "360281",
        "n": "乐平市"
      }]
    }, {
      "v": "360300",
      "n": "萍乡市",
      "c": [{"v": "360302", "n": "安源区"}, {"v": "360313", "n": "湘东区"}, {"v": "360321", "n": "莲花县"}, {
        "v": "360322",
        "n": "上栗县"
      }, {"v": "360323", "n": "芦溪县"}]
    }, {
      "v": "360400",
      "n": "九江市",
      "c": [{"v": "360402", "n": "濂溪区"}, {"v": "360403", "n": "浔阳区"}, {"v": "360404", "n": "柴桑区"}, {
        "v": "360423",
        "n": "武宁县"
      }, {"v": "360424", "n": "修水县"}, {"v": "360425", "n": "永修县"}, {"v": "360426", "n": "德安县"}, {
        "v": "360428",
        "n": "都昌县"
      }, {"v": "360429", "n": "湖口县"}, {"v": "360430", "n": "彭泽县"}, {"v": "360481", "n": "瑞昌市"}, {
        "v": "360482",
        "n": "共青城市"
      }, {"v": "360483", "n": "庐山市"}]
    }, {"v": "360500", "n": "新余市", "c": [{"v": "360502", "n": "渝水区"}, {"v": "360521", "n": "分宜县"}]}, {
      "v": "360600",
      "n": "鹰潭市",
      "c": [{"v": "360602", "n": "月湖区"}, {"v": "360603", "n": "余江区"}, {"v": "360681", "n": "贵溪市"}]
    }, {
      "v": "360700",
      "n": "赣州市",
      "c": [{"v": "360702", "n": "章贡区"}, {"v": "360703", "n": "南康区"}, {"v": "360704", "n": "赣县区"}, {
        "v": "360722",
        "n": "信丰县"
      }, {"v": "360723", "n": "大余县"}, {"v": "360724", "n": "上犹县"}, {"v": "360725", "n": "崇义县"}, {
        "v": "360726",
        "n": "安远县"
      }, {"v": "360727", "n": "龙南县"}, {"v": "360728", "n": "定南县"}, {"v": "360729", "n": "全南县"}, {
        "v": "360730",
        "n": "宁都县"
      }, {"v": "360731", "n": "于都县"}, {"v": "360732", "n": "兴国县"}, {"v": "360733", "n": "会昌县"}, {
        "v": "360734",
        "n": "寻乌县"
      }, {"v": "360735", "n": "石城县"}, {"v": "360781", "n": "瑞金市"}]
    }, {
      "v": "360800",
      "n": "吉安市",
      "c": [{"v": "360802", "n": "吉州区"}, {"v": "360803", "n": "青原区"}, {"v": "360821", "n": "吉安县"}, {
        "v": "360822",
        "n": "吉水县"
      }, {"v": "360823", "n": "峡江县"}, {"v": "360824", "n": "新干县"}, {"v": "360825", "n": "永丰县"}, {
        "v": "360826",
        "n": "泰和县"
      }, {"v": "360827", "n": "遂川县"}, {"v": "360828", "n": "万安县"}, {"v": "360829", "n": "安福县"}, {
        "v": "360830",
        "n": "永新县"
      }, {"v": "360881", "n": "井冈山市"}]
    }, {
      "v": "360900",
      "n": "宜春市",
      "c": [{"v": "360902", "n": "袁州区"}, {"v": "360921", "n": "奉新县"}, {"v": "360922", "n": "万载县"}, {
        "v": "360923",
        "n": "上高县"
      }, {"v": "360924", "n": "宜丰县"}, {"v": "360925", "n": "靖安县"}, {"v": "360926", "n": "铜鼓县"}, {
        "v": "360981",
        "n": "丰城市"
      }, {"v": "360982", "n": "樟树市"}, {"v": "360983", "n": "高安市"}]
    }, {
      "v": "361000",
      "n": "抚州市",
      "c": [{"v": "361002", "n": "临川区"}, {"v": "361003", "n": "东乡区"}, {"v": "361021", "n": "南城县"}, {
        "v": "361022",
        "n": "黎川县"
      }, {"v": "361023", "n": "南丰县"}, {"v": "361024", "n": "崇仁县"}, {"v": "361025", "n": "乐安县"}, {
        "v": "361026",
        "n": "宜黄县"
      }, {"v": "361027", "n": "金溪县"}, {"v": "361028", "n": "资溪县"}, {"v": "361030", "n": "广昌县"}]
    }, {
      "v": "361100",
      "n": "上饶市",
      "c": [{"v": "361102", "n": "信州区"}, {"v": "361103", "n": "广丰区"}, {"v": "361104", "n": "广信区"}, {
        "v": "361123",
        "n": "玉山县"
      }, {"v": "361124", "n": "铅山县"}, {"v": "361125", "n": "横峰县"}, {"v": "361126", "n": "弋阳县"}, {
        "v": "361127",
        "n": "余干县"
      }, {"v": "361128", "n": "鄱阳县"}, {"v": "361129", "n": "万年县"}, {"v": "361130", "n": "婺源县"}, {
        "v": "361181",
        "n": "德兴市"
      }]
    }]
  }, {
    "v": "370000",
    "n": "山东省",
    "c": [{
      "v": "370100",
      "n": "济南市",
      "c": [{"v": "370102", "n": "历下区"}, {"v": "370103", "n": "市中区"}, {"v": "370104", "n": "槐荫区"}, {
        "v": "370105",
        "n": "天桥区"
      }, {"v": "370112", "n": "历城区"}, {"v": "370113", "n": "长清区"}, {"v": "370114", "n": "章丘区"}, {
        "v": "370115",
        "n": "济阳区"
      }, {"v": "370116", "n": "莱芜区"}, {"v": "370117", "n": "钢城区"}, {"v": "370124", "n": "平阴县"}, {
        "v": "370126",
        "n": "商河县"
      }]
    }, {
      "v": "370200",
      "n": "青岛市",
      "c": [{"v": "370202", "n": "市南区"}, {"v": "370203", "n": "市北区"}, {"v": "370211", "n": "黄岛区"}, {
        "v": "370212",
        "n": "崂山区"
      }, {"v": "370213", "n": "李沧区"}, {"v": "370214", "n": "城阳区"}, {"v": "370215", "n": "即墨区"}, {
        "v": "370281",
        "n": "胶州市"
      }, {"v": "370283", "n": "平度市"}, {"v": "370285", "n": "莱西市"}]
    }, {
      "v": "370300",
      "n": "淄博市",
      "c": [{"v": "370302", "n": "淄川区"}, {"v": "370303", "n": "张店区"}, {"v": "370304", "n": "博山区"}, {
        "v": "370305",
        "n": "临淄区"
      }, {"v": "370306", "n": "周村区"}, {"v": "370321", "n": "桓台县"}, {"v": "370322", "n": "高青县"}, {
        "v": "370323",
        "n": "沂源县"
      }]
    }, {
      "v": "370400",
      "n": "枣庄市",
      "c": [{"v": "370402", "n": "市中区"}, {"v": "370403", "n": "薛城区"}, {"v": "370404", "n": "峄城区"}, {
        "v": "370405",
        "n": "台儿庄区"
      }, {"v": "370406", "n": "山亭区"}, {"v": "370481", "n": "滕州市"}]
    }, {
      "v": "370500",
      "n": "东营市",
      "c": [{"v": "370502", "n": "东营区"}, {"v": "370503", "n": "河口区"}, {"v": "370505", "n": "垦利区"}, {
        "v": "370522",
        "n": "利津县"
      }, {"v": "370523", "n": "广饶县"}]
    }, {
      "v": "370600",
      "n": "烟台市",
      "c": [{"v": "370602", "n": "芝罘区"}, {"v": "370611", "n": "福山区"}, {"v": "370612", "n": "牟平区"}, {
        "v": "370613",
        "n": "莱山区"
      }, {"v": "370634", "n": "长岛县"}, {"v": "370681", "n": "龙口市"}, {"v": "370682", "n": "莱阳市"}, {
        "v": "370683",
        "n": "莱州市"
      }, {"v": "370684", "n": "蓬莱市"}, {"v": "370685", "n": "招远市"}, {"v": "370686", "n": "栖霞市"}, {
        "v": "370687",
        "n": "海阳市"
      }]
    }, {
      "v": "370700",
      "n": "潍坊市",
      "c": [{"v": "370702", "n": "潍城区"}, {"v": "370703", "n": "寒亭区"}, {"v": "370704", "n": "坊子区"}, {
        "v": "370705",
        "n": "奎文区"
      }, {"v": "370724", "n": "临朐县"}, {"v": "370725", "n": "昌乐县"}, {"v": "370781", "n": "青州市"}, {
        "v": "370782",
        "n": "诸城市"
      }, {"v": "370783", "n": "寿光市"}, {"v": "370784", "n": "安丘市"}, {"v": "370785", "n": "高密市"}, {
        "v": "370786",
        "n": "昌邑市"
      }]
    }, {
      "v": "370800",
      "n": "济宁市",
      "c": [{"v": "370811", "n": "任城区"}, {"v": "370812", "n": "兖州区"}, {"v": "370826", "n": "微山县"}, {
        "v": "370827",
        "n": "鱼台县"
      }, {"v": "370828", "n": "金乡县"}, {"v": "370829", "n": "嘉祥县"}, {"v": "370830", "n": "汶上县"}, {
        "v": "370831",
        "n": "泗水县"
      }, {"v": "370832", "n": "梁山县"}, {"v": "370881", "n": "曲阜市"}, {"v": "370883", "n": "邹城市"}]
    }, {
      "v": "370900",
      "n": "泰安市",
      "c": [{"v": "370902", "n": "泰山区"}, {"v": "370911", "n": "岱岳区"}, {"v": "370921", "n": "宁阳县"}, {
        "v": "370923",
        "n": "东平县"
      }, {"v": "370982", "n": "新泰市"}, {"v": "370983", "n": "肥城市"}]
    }, {
      "v": "371000",
      "n": "威海市",
      "c": [{"v": "371002", "n": "环翠区"}, {"v": "371003", "n": "文登区"}, {"v": "371082", "n": "荣成市"}, {
        "v": "371083",
        "n": "乳山市"
      }]
    }, {
      "v": "371100",
      "n": "日照市",
      "c": [{"v": "371102", "n": "东港区"}, {"v": "371103", "n": "岚山区"}, {"v": "371121", "n": "五莲县"}, {
        "v": "371122",
        "n": "莒县"
      }]
    }, {
      "v": "371300",
      "n": "临沂市",
      "c": [{"v": "371302", "n": "兰山区"}, {"v": "371311", "n": "罗庄区"}, {"v": "371312", "n": "河东区"}, {
        "v": "371321",
        "n": "沂南县"
      }, {"v": "371322", "n": "郯城县"}, {"v": "371323", "n": "沂水县"}, {"v": "371324", "n": "兰陵县"}, {
        "v": "371325",
        "n": "费县"
      }, {"v": "371326", "n": "平邑县"}, {"v": "371327", "n": "莒南县"}, {"v": "371328", "n": "蒙阴县"}, {
        "v": "371329",
        "n": "临沭县"
      }]
    }, {
      "v": "371400",
      "n": "德州市",
      "c": [{"v": "371402", "n": "德城区"}, {"v": "371403", "n": "陵城区"}, {"v": "371422", "n": "宁津县"}, {
        "v": "371423",
        "n": "庆云县"
      }, {"v": "371424", "n": "临邑县"}, {"v": "371425", "n": "齐河县"}, {"v": "371426", "n": "平原县"}, {
        "v": "371427",
        "n": "夏津县"
      }, {"v": "371428", "n": "武城县"}, {"v": "371481", "n": "乐陵市"}, {"v": "371482", "n": "禹城市"}]
    }, {
      "v": "371500",
      "n": "聊城市",
      "c": [{"v": "371502", "n": "东昌府区"}, {"v": "371503", "n": "茌平区"}, {"v": "371521", "n": "阳谷县"}, {
        "v": "371522",
        "n": "莘县"
      }, {"v": "371524", "n": "东阿县"}, {"v": "371525", "n": "冠县"}, {"v": "371526", "n": "高唐县"}, {
        "v": "371581",
        "n": "临清市"
      }]
    }, {
      "v": "371600",
      "n": "滨州市",
      "c": [{"v": "371602", "n": "滨城区"}, {"v": "371603", "n": "沾化区"}, {"v": "371621", "n": "惠民县"}, {
        "v": "371622",
        "n": "阳信县"
      }, {"v": "371623", "n": "无棣县"}, {"v": "371625", "n": "博兴县"}, {"v": "371681", "n": "邹平市"}]
    }, {
      "v": "371700",
      "n": "菏泽市",
      "c": [{"v": "371702", "n": "牡丹区"}, {"v": "371703", "n": "定陶区"}, {"v": "371721", "n": "曹县"}, {
        "v": "371722",
        "n": "单县"
      }, {"v": "371723", "n": "成武县"}, {"v": "371724", "n": "巨野县"}, {"v": "371725", "n": "郓城县"}, {
        "v": "371726",
        "n": "鄄城县"
      }, {"v": "371728", "n": "东明县"}]
    }]
  }, {
    "v": "410000",
    "n": "河南省",
    "c": [{
      "v": "410100",
      "n": "郑州市",
      "c": [{"v": "410102", "n": "中原区"}, {"v": "410103", "n": "二七区"}, {"v": "410104", "n": "管城回族区"}, {
        "v": "410105",
        "n": "金水区"
      }, {"v": "410106", "n": "上街区"}, {"v": "410108", "n": "惠济区"}, {"v": "410122", "n": "中牟县"}, {
        "v": "410181",
        "n": "巩义市"
      }, {"v": "410182", "n": "荥阳市"}, {"v": "410183", "n": "新密市"}, {"v": "410184", "n": "新郑市"}, {
        "v": "410185",
        "n": "登封市"
      }]
    }, {
      "v": "410200",
      "n": "开封市",
      "c": [{"v": "410202", "n": "龙亭区"}, {"v": "410203", "n": "顺河回族区"}, {"v": "410204", "n": "鼓楼区"}, {
        "v": "410205",
        "n": "禹王台区"
      }, {"v": "410212", "n": "祥符区"}, {"v": "410221", "n": "杞县"}, {"v": "410222", "n": "通许县"}, {
        "v": "410223",
        "n": "尉氏县"
      }, {"v": "410225", "n": "兰考县"}]
    }, {
      "v": "410300",
      "n": "洛阳市",
      "c": [{"v": "410302", "n": "老城区"}, {"v": "410303", "n": "西工区"}, {"v": "410304", "n": "瀍河回族区"}, {
        "v": "410305",
        "n": "涧西区"
      }, {"v": "410306", "n": "吉利区"}, {"v": "410311", "n": "洛龙区"}, {"v": "410322", "n": "孟津县"}, {
        "v": "410323",
        "n": "新安县"
      }, {"v": "410324", "n": "栾川县"}, {"v": "410325", "n": "嵩县"}, {"v": "410326", "n": "汝阳县"}, {
        "v": "410327",
        "n": "宜阳县"
      }, {"v": "410328", "n": "洛宁县"}, {"v": "410329", "n": "伊川县"}, {"v": "410381", "n": "偃师市"}]
    }, {
      "v": "410400",
      "n": "平顶山市",
      "c": [{"v": "410402", "n": "新华区"}, {"v": "410403", "n": "卫东区"}, {"v": "410404", "n": "石龙区"}, {
        "v": "410411",
        "n": "湛河区"
      }, {"v": "410421", "n": "宝丰县"}, {"v": "410422", "n": "叶县"}, {"v": "410423", "n": "鲁山县"}, {
        "v": "410425",
        "n": "郏县"
      }, {"v": "410481", "n": "舞钢市"}, {"v": "410482", "n": "汝州市"}]
    }, {
      "v": "410500",
      "n": "安阳市",
      "c": [{"v": "410502", "n": "文峰区"}, {"v": "410503", "n": "北关区"}, {"v": "410505", "n": "殷都区"}, {
        "v": "410506",
        "n": "龙安区"
      }, {"v": "410522", "n": "安阳县"}, {"v": "410523", "n": "汤阴县"}, {"v": "410526", "n": "滑县"}, {
        "v": "410527",
        "n": "内黄县"
      }, {"v": "410581", "n": "林州市"}]
    }, {
      "v": "410600",
      "n": "鹤壁市",
      "c": [{"v": "410602", "n": "鹤山区"}, {"v": "410603", "n": "山城区"}, {"v": "410611", "n": "淇滨区"}, {
        "v": "410621",
        "n": "浚县"
      }, {"v": "410622", "n": "淇县"}]
    }, {
      "v": "410700",
      "n": "新乡市",
      "c": [{"v": "410702", "n": "红旗区"}, {"v": "410703", "n": "卫滨区"}, {"v": "410704", "n": "凤泉区"}, {
        "v": "410711",
        "n": "牧野区"
      }, {"v": "410721", "n": "新乡县"}, {"v": "410724", "n": "获嘉县"}, {"v": "410725", "n": "原阳县"}, {
        "v": "410726",
        "n": "延津县"
      }, {"v": "410727", "n": "封丘县"}, {"v": "410781", "n": "卫辉市"}, {"v": "410782", "n": "辉县市"}, {
        "v": "410783",
        "n": "长垣市"
      }]
    }, {
      "v": "410800",
      "n": "焦作市",
      "c": [{"v": "410802", "n": "解放区"}, {"v": "410803", "n": "中站区"}, {"v": "410804", "n": "马村区"}, {
        "v": "410811",
        "n": "山阳区"
      }, {"v": "410821", "n": "修武县"}, {"v": "410822", "n": "博爱县"}, {"v": "410823", "n": "武陟县"}, {
        "v": "410825",
        "n": "温县"
      }, {"v": "410882", "n": "沁阳市"}, {"v": "410883", "n": "孟州市"}]
    }, {
      "v": "410900",
      "n": "濮阳市",
      "c": [{"v": "410902", "n": "华龙区"}, {"v": "410922", "n": "清丰县"}, {"v": "410923", "n": "南乐县"}, {
        "v": "410926",
        "n": "范县"
      }, {"v": "410927", "n": "台前县"}, {"v": "410928", "n": "濮阳县"}]
    }, {
      "v": "411000",
      "n": "许昌市",
      "c": [{"v": "411002", "n": "魏都区"}, {"v": "411003", "n": "建安区"}, {"v": "411024", "n": "鄢陵县"}, {
        "v": "411025",
        "n": "襄城县"
      }, {"v": "411081", "n": "禹州市"}, {"v": "411082", "n": "长葛市"}]
    }, {
      "v": "411100",
      "n": "漯河市",
      "c": [{"v": "411102", "n": "源汇区"}, {"v": "411103", "n": "郾城区"}, {"v": "411104", "n": "召陵区"}, {
        "v": "411121",
        "n": "舞阳县"
      }, {"v": "411122", "n": "临颍县"}]
    }, {
      "v": "411200",
      "n": "三门峡市",
      "c": [{"v": "411202", "n": "湖滨区"}, {"v": "411203", "n": "陕州区"}, {"v": "411221", "n": "渑池县"}, {
        "v": "411224",
        "n": "卢氏县"
      }, {"v": "411281", "n": "义马市"}, {"v": "411282", "n": "灵宝市"}]
    }, {
      "v": "411300",
      "n": "南阳市",
      "c": [{"v": "411302", "n": "宛城区"}, {"v": "411303", "n": "卧龙区"}, {"v": "411321", "n": "南召县"}, {
        "v": "411322",
        "n": "方城县"
      }, {"v": "411323", "n": "西峡县"}, {"v": "411324", "n": "镇平县"}, {"v": "411325", "n": "内乡县"}, {
        "v": "411326",
        "n": "淅川县"
      }, {"v": "411327", "n": "社旗县"}, {"v": "411328", "n": "唐河县"}, {"v": "411329", "n": "新野县"}, {
        "v": "411330",
        "n": "桐柏县"
      }, {"v": "411381", "n": "邓州市"}]
    }, {
      "v": "411400",
      "n": "商丘市",
      "c": [{"v": "411402", "n": "梁园区"}, {"v": "411403", "n": "睢阳区"}, {"v": "411421", "n": "民权县"}, {
        "v": "411422",
        "n": "睢县"
      }, {"v": "411423", "n": "宁陵县"}, {"v": "411424", "n": "柘城县"}, {"v": "411425", "n": "虞城县"}, {
        "v": "411426",
        "n": "夏邑县"
      }, {"v": "411481", "n": "永城市"}]
    }, {
      "v": "411500",
      "n": "信阳市",
      "c": [{"v": "411502", "n": "浉河区"}, {"v": "411503", "n": "平桥区"}, {"v": "411521", "n": "罗山县"}, {
        "v": "411522",
        "n": "光山县"
      }, {"v": "411523", "n": "新县"}, {"v": "411524", "n": "商城县"}, {"v": "411525", "n": "固始县"}, {
        "v": "411526",
        "n": "潢川县"
      }, {"v": "411527", "n": "淮滨县"}, {"v": "411528", "n": "息县"}]
    }, {
      "v": "411600",
      "n": "周口市",
      "c": [{"v": "411602", "n": "川汇区"}, {"v": "411603", "n": "淮阳区"}, {"v": "411621", "n": "扶沟县"}, {
        "v": "411622",
        "n": "西华县"
      }, {"v": "411623", "n": "商水县"}, {"v": "411624", "n": "沈丘县"}, {"v": "411625", "n": "郸城县"}, {
        "v": "411627",
        "n": "太康县"
      }, {"v": "411628", "n": "鹿邑县"}, {"v": "411681", "n": "项城市"}]
    }, {
      "v": "411700",
      "n": "驻马店市",
      "c": [{"v": "411702", "n": "驿城区"}, {"v": "411721", "n": "西平县"}, {"v": "411722", "n": "上蔡县"}, {
        "v": "411723",
        "n": "平舆县"
      }, {"v": "411724", "n": "正阳县"}, {"v": "411725", "n": "确山县"}, {"v": "411726", "n": "泌阳县"}, {
        "v": "411727",
        "n": "汝南县"
      }, {"v": "411728", "n": "遂平县"}, {"v": "411729", "n": "新蔡县"}]
    }]
  }, {
    "v": "420000",
    "n": "湖北省",
    "c": [{
      "v": "420100",
      "n": "武汉市",
      "c": [{"v": "420102", "n": "江岸区"}, {"v": "420103", "n": "江汉区"}, {"v": "420104", "n": "硚口区"}, {
        "v": "420105",
        "n": "汉阳区"
      }, {"v": "420106", "n": "武昌区"}, {"v": "420107", "n": "青山区"}, {"v": "420111", "n": "洪山区"}, {
        "v": "420112",
        "n": "东西湖区"
      }, {"v": "420113", "n": "汉南区"}, {"v": "420114", "n": "蔡甸区"}, {"v": "420115", "n": "江夏区"}, {
        "v": "420116",
        "n": "黄陂区"
      }, {"v": "420117", "n": "新洲区"}]
    }, {
      "v": "420200",
      "n": "黄石市",
      "c": [{"v": "420202", "n": "黄石港区"}, {"v": "420203", "n": "西塞山区"}, {"v": "420204", "n": "下陆区"}, {
        "v": "420205",
        "n": "铁山区"
      }, {"v": "420222", "n": "阳新县"}, {"v": "420281", "n": "大冶市"}]
    }, {
      "v": "420300",
      "n": "十堰市",
      "c": [{"v": "420302", "n": "茅箭区"}, {"v": "420303", "n": "张湾区"}, {"v": "420304", "n": "郧阳区"}, {
        "v": "420322",
        "n": "郧西县"
      }, {"v": "420323", "n": "竹山县"}, {"v": "420324", "n": "竹溪县"}, {"v": "420325", "n": "房县"}, {
        "v": "420381",
        "n": "丹江口市"
      }]
    }, {
      "v": "420500",
      "n": "宜昌市",
      "c": [{"v": "420502", "n": "西陵区"}, {"v": "420503", "n": "伍家岗区"}, {"v": "420504", "n": "点军区"}, {
        "v": "420505",
        "n": "猇亭区"
      }, {"v": "420506", "n": "夷陵区"}, {"v": "420525", "n": "远安县"}, {"v": "420526", "n": "兴山县"}, {
        "v": "420527",
        "n": "秭归县"
      }, {"v": "420528", "n": "长阳土家族自治县"}, {"v": "420529", "n": "五峰土家族自治县"}, {
        "v": "420581",
        "n": "宜都市"
      }, {"v": "420582", "n": "当阳市"}, {"v": "420583", "n": "枝江市"}]
    }, {
      "v": "420600",
      "n": "襄阳市",
      "c": [{"v": "420602", "n": "襄城区"}, {"v": "420606", "n": "樊城区"}, {"v": "420607", "n": "襄州区"}, {
        "v": "420624",
        "n": "南漳县"
      }, {"v": "420625", "n": "谷城县"}, {"v": "420626", "n": "保康县"}, {"v": "420682", "n": "老河口市"}, {
        "v": "420683",
        "n": "枣阳市"
      }, {"v": "420684", "n": "宜城市"}]
    }, {
      "v": "420700",
      "n": "鄂州市",
      "c": [{"v": "420702", "n": "梁子湖区"}, {"v": "420703", "n": "华容区"}, {"v": "420704", "n": "鄂城区"}]
    }, {
      "v": "420800",
      "n": "荆门市",
      "c": [{"v": "420802", "n": "东宝区"}, {"v": "420804", "n": "掇刀区"}, {"v": "420822", "n": "沙洋县"}, {
        "v": "420881",
        "n": "钟祥市"
      }, {"v": "420882", "n": "京山市"}]
    }, {
      "v": "420900",
      "n": "孝感市",
      "c": [{"v": "420902", "n": "孝南区"}, {"v": "420921", "n": "孝昌县"}, {"v": "420922", "n": "大悟县"}, {
        "v": "420923",
        "n": "云梦县"
      }, {"v": "420981", "n": "应城市"}, {"v": "420982", "n": "安陆市"}, {"v": "420984", "n": "汉川市"}]
    }, {
      "v": "421000",
      "n": "荆州市",
      "c": [{"v": "421002", "n": "沙市区"}, {"v": "421003", "n": "荆州区"}, {"v": "421022", "n": "公安县"}, {
        "v": "421023",
        "n": "监利县"
      }, {"v": "421024", "n": "江陵县"}, {"v": "421081", "n": "石首市"}, {"v": "421083", "n": "洪湖市"}, {
        "v": "421087",
        "n": "松滋市"
      }]
    }, {
      "v": "421100",
      "n": "黄冈市",
      "c": [{"v": "421102", "n": "黄州区"}, {"v": "421121", "n": "团风县"}, {"v": "421122", "n": "红安县"}, {
        "v": "421123",
        "n": "罗田县"
      }, {"v": "421124", "n": "英山县"}, {"v": "421125", "n": "浠水县"}, {"v": "421126", "n": "蕲春县"}, {
        "v": "421127",
        "n": "黄梅县"
      }, {"v": "421181", "n": "麻城市"}, {"v": "421182", "n": "武穴市"}]
    }, {
      "v": "421200",
      "n": "咸宁市",
      "c": [{"v": "421202", "n": "咸安区"}, {"v": "421221", "n": "嘉鱼县"}, {"v": "421222", "n": "通城县"}, {
        "v": "421223",
        "n": "崇阳县"
      }, {"v": "421224", "n": "通山县"}, {"v": "421281", "n": "赤壁市"}]
    }, {
      "v": "421300",
      "n": "随州市",
      "c": [{"v": "421303", "n": "曾都区"}, {"v": "421321", "n": "随县"}, {"v": "421381", "n": "广水市"}]
    }, {
      "v": "422800",
      "n": "恩施土家族苗族自治州",
      "c": [{"v": "422801", "n": "恩施市"}, {"v": "422802", "n": "利川市"}, {"v": "422822", "n": "建始县"}, {
        "v": "422823",
        "n": "巴东县"
      }, {"v": "422825", "n": "宣恩县"}, {"v": "422826", "n": "咸丰县"}, {"v": "422827", "n": "来凤县"}, {
        "v": "422828",
        "n": "鹤峰县"
      }]
    }]
  }, {
    "v": "430000",
    "n": "湖南省",
    "c": [{
      "v": "430100",
      "n": "长沙市",
      "c": [{"v": "430102", "n": "芙蓉区"}, {"v": "430103", "n": "天心区"}, {"v": "430104", "n": "岳麓区"}, {
        "v": "430105",
        "n": "开福区"
      }, {"v": "430111", "n": "雨花区"}, {"v": "430112", "n": "望城区"}, {"v": "430121", "n": "长沙县"}, {
        "v": "430181",
        "n": "浏阳市"
      }, {"v": "430182", "n": "宁乡市"}]
    }, {
      "v": "430200",
      "n": "株洲市",
      "c": [{"v": "430202", "n": "荷塘区"}, {"v": "430203", "n": "芦淞区"}, {"v": "430204", "n": "石峰区"}, {
        "v": "430211",
        "n": "天元区"
      }, {"v": "430212", "n": "渌口区"}, {"v": "430223", "n": "攸县"}, {"v": "430224", "n": "茶陵县"}, {
        "v": "430225",
        "n": "炎陵县"
      }, {"v": "430281", "n": "醴陵市"}]
    }, {
      "v": "430300",
      "n": "湘潭市",
      "c": [{"v": "430302", "n": "雨湖区"}, {"v": "430304", "n": "岳塘区"}, {"v": "430321", "n": "湘潭县"}, {
        "v": "430381",
        "n": "湘乡市"
      }, {"v": "430382", "n": "韶山市"}]
    }, {
      "v": "430400",
      "n": "衡阳市",
      "c": [{"v": "430405", "n": "珠晖区"}, {"v": "430406", "n": "雁峰区"}, {"v": "430407", "n": "石鼓区"}, {
        "v": "430408",
        "n": "蒸湘区"
      }, {"v": "430412", "n": "南岳区"}, {"v": "430421", "n": "衡阳县"}, {"v": "430422", "n": "衡南县"}, {
        "v": "430423",
        "n": "衡山县"
      }, {"v": "430424", "n": "衡东县"}, {"v": "430426", "n": "祁东县"}, {"v": "430481", "n": "耒阳市"}, {
        "v": "430482",
        "n": "常宁市"
      }]
    }, {
      "v": "430500",
      "n": "邵阳市",
      "c": [{"v": "430502", "n": "双清区"}, {"v": "430503", "n": "大祥区"}, {"v": "430511", "n": "北塔区"}, {
        "v": "430522",
        "n": "新邵县"
      }, {"v": "430523", "n": "邵阳县"}, {"v": "430524", "n": "隆回县"}, {"v": "430525", "n": "洞口县"}, {
        "v": "430527",
        "n": "绥宁县"
      }, {"v": "430528", "n": "新宁县"}, {"v": "430529", "n": "城步苗族自治县"}, {"v": "430581", "n": "武冈市"}, {
        "v": "430582",
        "n": "邵东市"
      }]
    }, {
      "v": "430600",
      "n": "岳阳市",
      "c": [{"v": "430602", "n": "岳阳楼区"}, {"v": "430603", "n": "云溪区"}, {"v": "430611", "n": "君山区"}, {
        "v": "430621",
        "n": "岳阳县"
      }, {"v": "430623", "n": "华容县"}, {"v": "430624", "n": "湘阴县"}, {"v": "430626", "n": "平江县"}, {
        "v": "430681",
        "n": "汨罗市"
      }, {"v": "430682", "n": "临湘市"}]
    }, {
      "v": "430700",
      "n": "常德市",
      "c": [{"v": "430702", "n": "武陵区"}, {"v": "430703", "n": "鼎城区"}, {"v": "430721", "n": "安乡县"}, {
        "v": "430722",
        "n": "汉寿县"
      }, {"v": "430723", "n": "澧县"}, {"v": "430724", "n": "临澧县"}, {"v": "430725", "n": "桃源县"}, {
        "v": "430726",
        "n": "石门县"
      }, {"v": "430781", "n": "津市市"}]
    }, {
      "v": "430800",
      "n": "张家界市",
      "c": [{"v": "430802", "n": "永定区"}, {"v": "430811", "n": "武陵源区"}, {"v": "430821", "n": "慈利县"}, {
        "v": "430822",
        "n": "桑植县"
      }]
    }, {
      "v": "430900",
      "n": "益阳市",
      "c": [{"v": "430902", "n": "资阳区"}, {"v": "430903", "n": "赫山区"}, {"v": "430921", "n": "南县"}, {
        "v": "430922",
        "n": "桃江县"
      }, {"v": "430923", "n": "安化县"}, {"v": "430981", "n": "沅江市"}]
    }, {
      "v": "431000",
      "n": "郴州市",
      "c": [{"v": "431002", "n": "北湖区"}, {"v": "431003", "n": "苏仙区"}, {"v": "431021", "n": "桂阳县"}, {
        "v": "431022",
        "n": "宜章县"
      }, {"v": "431023", "n": "永兴县"}, {"v": "431024", "n": "嘉禾县"}, {"v": "431025", "n": "临武县"}, {
        "v": "431026",
        "n": "汝城县"
      }, {"v": "431027", "n": "桂东县"}, {"v": "431028", "n": "安仁县"}, {"v": "431081", "n": "资兴市"}]
    }, {
      "v": "431100",
      "n": "永州市",
      "c": [{"v": "431102", "n": "零陵区"}, {"v": "431103", "n": "冷水滩区"}, {"v": "431121", "n": "祁阳县"}, {
        "v": "431122",
        "n": "东安县"
      }, {"v": "431123", "n": "双牌县"}, {"v": "431124", "n": "道县"}, {"v": "431125", "n": "江永县"}, {
        "v": "431126",
        "n": "宁远县"
      }, {"v": "431127", "n": "蓝山县"}, {"v": "431128", "n": "新田县"}, {"v": "431129", "n": "江华瑶族自治县"}]
    }, {
      "v": "431200",
      "n": "怀化市",
      "c": [{"v": "431202", "n": "鹤城区"}, {"v": "431221", "n": "中方县"}, {"v": "431222", "n": "沅陵县"}, {
        "v": "431223",
        "n": "辰溪县"
      }, {"v": "431224", "n": "溆浦县"}, {"v": "431225", "n": "会同县"}, {"v": "431226", "n": "麻阳苗族自治县"}, {
        "v": "431227",
        "n": "新晃侗族自治县"
      }, {"v": "431228", "n": "芷江侗族自治县"}, {"v": "431229", "n": "靖州苗族侗族自治县"}, {
        "v": "431230",
        "n": "通道侗族自治县"
      }, {"v": "431281", "n": "洪江市"}]
    }, {
      "v": "431300",
      "n": "娄底市",
      "c": [{"v": "431302", "n": "娄星区"}, {"v": "431321", "n": "双峰县"}, {"v": "431322", "n": "新化县"}, {
        "v": "431381",
        "n": "冷水江市"
      }, {"v": "431382", "n": "涟源市"}]
    }, {
      "v": "433100",
      "n": "湘西土家族苗族自治州",
      "c": [{"v": "433101", "n": "吉首市"}, {"v": "433122", "n": "泸溪县"}, {"v": "433123", "n": "凤凰县"}, {
        "v": "433124",
        "n": "花垣县"
      }, {"v": "433125", "n": "保靖县"}, {"v": "433126", "n": "古丈县"}, {"v": "433127", "n": "永顺县"}, {
        "v": "433130",
        "n": "龙山县"
      }]
    }]
  }, {
    "v": "440000",
    "n": "广东省",
    "c": [{
      "v": "440100",
      "n": "广州市",
      "c": [{"v": "440103", "n": "荔湾区"}, {"v": "440104", "n": "越秀区"}, {"v": "440105", "n": "海珠区"}, {
        "v": "440106",
        "n": "天河区"
      }, {"v": "440111", "n": "白云区"}, {"v": "440112", "n": "黄埔区"}, {"v": "440113", "n": "番禺区"}, {
        "v": "440114",
        "n": "花都区"
      }, {"v": "440115", "n": "南沙区"}, {"v": "440117", "n": "从化区"}, {"v": "440118", "n": "增城区"}]
    }, {
      "v": "440200",
      "n": "韶关市",
      "c": [{"v": "440203", "n": "武江区"}, {"v": "440204", "n": "浈江区"}, {"v": "440205", "n": "曲江区"}, {
        "v": "440222",
        "n": "始兴县"
      }, {"v": "440224", "n": "仁化县"}, {"v": "440229", "n": "翁源县"}, {"v": "440232", "n": "乳源瑶族自治县"}, {
        "v": "440233",
        "n": "新丰县"
      }, {"v": "440281", "n": "乐昌市"}, {"v": "440282", "n": "南雄市"}]
    }, {
      "v": "440300",
      "n": "深圳市",
      "c": [{"v": "440303", "n": "罗湖区"}, {"v": "440304", "n": "福田区"}, {"v": "440305", "n": "南山区"}, {
        "v": "440306",
        "n": "宝安区"
      }, {"v": "440307", "n": "龙岗区"}, {"v": "440308", "n": "盐田区"}, {"v": "440309", "n": "龙华区"}, {
        "v": "440310",
        "n": "坪山区"
      }, {"v": "440311", "n": "光明区"}]
    }, {
      "v": "440400",
      "n": "珠海市",
      "c": [{"v": "440402", "n": "香洲区"}, {"v": "440403", "n": "斗门区"}, {"v": "440404", "n": "金湾区"}]
    }, {
      "v": "440500",
      "n": "汕头市",
      "c": [{"v": "440507", "n": "龙湖区"}, {"v": "440511", "n": "金平区"}, {"v": "440512", "n": "濠江区"}, {
        "v": "440513",
        "n": "潮阳区"
      }, {"v": "440514", "n": "潮南区"}, {"v": "440515", "n": "澄海区"}, {"v": "440523", "n": "南澳县"}]
    }, {
      "v": "440600",
      "n": "佛山市",
      "c": [{"v": "440604", "n": "禅城区"}, {"v": "440605", "n": "南海区"}, {"v": "440606", "n": "顺德区"}, {
        "v": "440607",
        "n": "三水区"
      }, {"v": "440608", "n": "高明区"}]
    }, {
      "v": "440700",
      "n": "江门市",
      "c": [{"v": "440703", "n": "蓬江区"}, {"v": "440704", "n": "江海区"}, {"v": "440705", "n": "新会区"}, {
        "v": "440781",
        "n": "台山市"
      }, {"v": "440783", "n": "开平市"}, {"v": "440784", "n": "鹤山市"}, {"v": "440785", "n": "恩平市"}]
    }, {
      "v": "440800",
      "n": "湛江市",
      "c": [{"v": "440802", "n": "赤坎区"}, {"v": "440803", "n": "霞山区"}, {"v": "440804", "n": "坡头区"}, {
        "v": "440811",
        "n": "麻章区"
      }, {"v": "440823", "n": "遂溪县"}, {"v": "440825", "n": "徐闻县"}, {"v": "440881", "n": "廉江市"}, {
        "v": "440882",
        "n": "雷州市"
      }, {"v": "440883", "n": "吴川市"}]
    }, {
      "v": "440900",
      "n": "茂名市",
      "c": [{"v": "440902", "n": "茂南区"}, {"v": "440904", "n": "电白区"}, {"v": "440981", "n": "高州市"}, {
        "v": "440982",
        "n": "化州市"
      }, {"v": "440983", "n": "信宜市"}]
    }, {
      "v": "441200",
      "n": "肇庆市",
      "c": [{"v": "441202", "n": "端州区"}, {"v": "441203", "n": "鼎湖区"}, {"v": "441204", "n": "高要区"}, {
        "v": "441223",
        "n": "广宁县"
      }, {"v": "441224", "n": "怀集县"}, {"v": "441225", "n": "封开县"}, {"v": "441226", "n": "德庆县"}, {
        "v": "441284",
        "n": "四会市"
      }]
    }, {
      "v": "441300",
      "n": "惠州市",
      "c": [{"v": "441302", "n": "惠城区"}, {"v": "441303", "n": "惠阳区"}, {"v": "441322", "n": "博罗县"}, {
        "v": "441323",
        "n": "惠东县"
      }, {"v": "441324", "n": "龙门县"}]
    }, {
      "v": "441400",
      "n": "梅州市",
      "c": [{"v": "441402", "n": "梅江区"}, {"v": "441403", "n": "梅县区"}, {"v": "441422", "n": "大埔县"}, {
        "v": "441423",
        "n": "丰顺县"
      }, {"v": "441424", "n": "五华县"}, {"v": "441426", "n": "平远县"}, {"v": "441427", "n": "蕉岭县"}, {
        "v": "441481",
        "n": "兴宁市"
      }]
    }, {
      "v": "441500",
      "n": "汕尾市",
      "c": [{"v": "441502", "n": "城区"}, {"v": "441521", "n": "海丰县"}, {"v": "441523", "n": "陆河县"}, {
        "v": "441581",
        "n": "陆丰市"
      }]
    }, {
      "v": "441600",
      "n": "河源市",
      "c": [{"v": "441602", "n": "源城区"}, {"v": "441621", "n": "紫金县"}, {"v": "441622", "n": "龙川县"}, {
        "v": "441623",
        "n": "连平县"
      }, {"v": "441624", "n": "和平县"}, {"v": "441625", "n": "东源县"}]
    }, {
      "v": "441700",
      "n": "阳江市",
      "c": [{"v": "441702", "n": "江城区"}, {"v": "441704", "n": "阳东区"}, {"v": "441721", "n": "阳西县"}, {
        "v": "441781",
        "n": "阳春市"
      }]
    }, {
      "v": "441800",
      "n": "清远市",
      "c": [{"v": "441802", "n": "清城区"}, {"v": "441803", "n": "清新区"}, {"v": "441821", "n": "佛冈县"}, {
        "v": "441823",
        "n": "阳山县"
      }, {"v": "441825", "n": "连山壮族瑶族自治县"}, {"v": "441826", "n": "连南瑶族自治县"}, {
        "v": "441881",
        "n": "英德市"
      }, {"v": "441882", "n": "连州市"}]
    }, {"v": "441900", "n": "东莞市", "c": [{"v": "441901", "n": "东莞市"}]}, {
      "v": "442000",
      "n": "中山市",
      "c": [{"v": "442001", "n": "中山市"}]
    }, {
      "v": "445100",
      "n": "潮州市",
      "c": [{"v": "445102", "n": "湘桥区"}, {"v": "445103", "n": "潮安区"}, {"v": "445122", "n": "饶平县"}]
    }, {
      "v": "445200",
      "n": "揭阳市",
      "c": [{"v": "445202", "n": "榕城区"}, {"v": "445203", "n": "揭东区"}, {"v": "445222", "n": "揭西县"}, {
        "v": "445224",
        "n": "惠来县"
      }, {"v": "445281", "n": "普宁市"}]
    }, {
      "v": "445300",
      "n": "云浮市",
      "c": [{"v": "445302", "n": "云城区"}, {"v": "445303", "n": "云安区"}, {"v": "445321", "n": "新兴县"}, {
        "v": "445322",
        "n": "郁南县"
      }, {"v": "445381", "n": "罗定市"}]
    }]
  }, {
    "v": "450000",
    "n": "广西壮族自治区",
    "c": [{
      "v": "450100",
      "n": "南宁市",
      "c": [{"v": "450102", "n": "兴宁区"}, {"v": "450103", "n": "青秀区"}, {"v": "450105", "n": "江南区"}, {
        "v": "450107",
        "n": "西乡塘区"
      }, {"v": "450108", "n": "良庆区"}, {"v": "450109", "n": "邕宁区"}, {"v": "450110", "n": "武鸣区"}, {
        "v": "450123",
        "n": "隆安县"
      }, {"v": "450124", "n": "马山县"}, {"v": "450125", "n": "上林县"}, {"v": "450126", "n": "宾阳县"}, {
        "v": "450127",
        "n": "横县"
      }]
    }, {
      "v": "450200",
      "n": "柳州市",
      "c": [{"v": "450202", "n": "城中区"}, {"v": "450203", "n": "鱼峰区"}, {"v": "450204", "n": "柳南区"}, {
        "v": "450205",
        "n": "柳北区"
      }, {"v": "450206", "n": "柳江区"}, {"v": "450222", "n": "柳城县"}, {"v": "450223", "n": "鹿寨县"}, {
        "v": "450224",
        "n": "融安县"
      }, {"v": "450225", "n": "融水苗族自治县"}, {"v": "450226", "n": "三江侗族自治县"}]
    }, {
      "v": "450300",
      "n": "桂林市",
      "c": [{"v": "450302", "n": "秀峰区"}, {"v": "450303", "n": "叠彩区"}, {"v": "450304", "n": "象山区"}, {
        "v": "450305",
        "n": "七星区"
      }, {"v": "450311", "n": "雁山区"}, {"v": "450312", "n": "临桂区"}, {"v": "450321", "n": "阳朔县"}, {
        "v": "450323",
        "n": "灵川县"
      }, {"v": "450324", "n": "全州县"}, {"v": "450325", "n": "兴安县"}, {"v": "450326", "n": "永福县"}, {
        "v": "450327",
        "n": "灌阳县"
      }, {"v": "450328", "n": "龙胜各族自治县"}, {"v": "450329", "n": "资源县"}, {"v": "450330", "n": "平乐县"}, {
        "v": "450332",
        "n": "恭城瑶族自治县"
      }, {"v": "450381", "n": "荔浦市"}]
    }, {
      "v": "450400",
      "n": "梧州市",
      "c": [{"v": "450403", "n": "万秀区"}, {"v": "450405", "n": "长洲区"}, {"v": "450406", "n": "龙圩区"}, {
        "v": "450421",
        "n": "苍梧县"
      }, {"v": "450422", "n": "藤县"}, {"v": "450423", "n": "蒙山县"}, {"v": "450481", "n": "岑溪市"}]
    }, {
      "v": "450500",
      "n": "北海市",
      "c": [{"v": "450502", "n": "海城区"}, {"v": "450503", "n": "银海区"}, {"v": "450512", "n": "铁山港区"}, {
        "v": "450521",
        "n": "合浦县"
      }]
    }, {
      "v": "450600",
      "n": "防城港市",
      "c": [{"v": "450602", "n": "港口区"}, {"v": "450603", "n": "防城区"}, {"v": "450621", "n": "上思县"}, {
        "v": "450681",
        "n": "东兴市"
      }]
    }, {
      "v": "450700",
      "n": "钦州市",
      "c": [{"v": "450702", "n": "钦南区"}, {"v": "450703", "n": "钦北区"}, {"v": "450721", "n": "灵山县"}, {
        "v": "450722",
        "n": "浦北县"
      }]
    }, {
      "v": "450800",
      "n": "贵港市",
      "c": [{"v": "450802", "n": "港北区"}, {"v": "450803", "n": "港南区"}, {"v": "450804", "n": "覃塘区"}, {
        "v": "450821",
        "n": "平南县"
      }, {"v": "450881", "n": "桂平市"}]
    }, {
      "v": "450900",
      "n": "玉林市",
      "c": [{"v": "450902", "n": "玉州区"}, {"v": "450903", "n": "福绵区"}, {"v": "450921", "n": "容县"}, {
        "v": "450922",
        "n": "陆川县"
      }, {"v": "450923", "n": "博白县"}, {"v": "450924", "n": "兴业县"}, {"v": "450981", "n": "北流市"}]
    }, {
      "v": "451000",
      "n": "百色市",
      "c": [{"v": "451002", "n": "右江区"}, {"v": "451003", "n": "田阳区"}, {"v": "451022", "n": "田东县"}, {
        "v": "451024",
        "n": "德保县"
      }, {"v": "451026", "n": "那坡县"}, {"v": "451027", "n": "凌云县"}, {"v": "451028", "n": "乐业县"}, {
        "v": "451029",
        "n": "田林县"
      }, {"v": "451030", "n": "西林县"}, {"v": "451031", "n": "隆林各族自治县"}, {"v": "451081", "n": "靖西市"}, {
        "v": "451082",
        "n": "平果市"
      }]
    }, {
      "v": "451100",
      "n": "贺州市",
      "c": [{"v": "451102", "n": "八步区"}, {"v": "451103", "n": "平桂区"}, {"v": "451121", "n": "昭平县"}, {
        "v": "451122",
        "n": "钟山县"
      }, {"v": "451123", "n": "富川瑶族自治县"}]
    }, {
      "v": "451200",
      "n": "河池市",
      "c": [{"v": "451202", "n": "金城江区"}, {"v": "451203", "n": "宜州区"}, {"v": "451221", "n": "南丹县"}, {
        "v": "451222",
        "n": "天峨县"
      }, {"v": "451223", "n": "凤山县"}, {"v": "451224", "n": "东兰县"}, {"v": "451225", "n": "罗城仫佬族自治县"}, {
        "v": "451226",
        "n": "环江毛南族自治县"
      }, {"v": "451227", "n": "巴马瑶族自治县"}, {"v": "451228", "n": "都安瑶族自治县"}, {"v": "451229", "n": "大化瑶族自治县"}]
    }, {
      "v": "451300",
      "n": "来宾市",
      "c": [{"v": "451302", "n": "兴宾区"}, {"v": "451321", "n": "忻城县"}, {"v": "451322", "n": "象州县"}, {
        "v": "451323",
        "n": "武宣县"
      }, {"v": "451324", "n": "金秀瑶族自治县"}, {"v": "451381", "n": "合山市"}]
    }, {
      "v": "451400",
      "n": "崇左市",
      "c": [{"v": "451402", "n": "江州区"}, {"v": "451421", "n": "扶绥县"}, {"v": "451422", "n": "宁明县"}, {
        "v": "451423",
        "n": "龙州县"
      }, {"v": "451424", "n": "大新县"}, {"v": "451425", "n": "天等县"}, {"v": "451481", "n": "凭祥市"}]
    }]
  }, {
    "v": "460000",
    "n": "海南省",
    "c": [{
      "v": "460100",
      "n": "海口市",
      "c": [{"v": "460101", "n": "市辖区"}, {"v": "460105", "n": "秀英区"}, {"v": "460106", "n": "龙华区"}, {
        "v": "460107",
        "n": "琼山区"
      }, {"v": "460108", "n": "美兰区"}]
    }, {
      "v": "460200",
      "n": "三亚市",
      "c": [{"v": "460201", "n": "市辖区"}, {"v": "460202", "n": "海棠区"}, {"v": "460203", "n": "吉阳区"}, {
        "v": "460204",
        "n": "天涯区"
      }, {"v": "460205", "n": "崖州区"}]
    }, {"v": "460300", "n": "三沙市", "c": [{"v": "460301", "n": "市辖区"}]}, {
      "v": "460400",
      "n": "儋州市",
      "c": [{"v": "460401", "n": "市辖区"}]
    }, {
      "v": "469000",
      "n": "省直辖县级行政区划",
      "c": [{"v": "469001", "n": "五指山市"}, {"v": "469002", "n": "琼海市"}, {"v": "469005", "n": "文昌市"}, {
        "v": "469006",
        "n": "万宁市"
      }, {"v": "469007", "n": "东方市"}, {"v": "469021", "n": "定安县"}, {"v": "469022", "n": "屯昌县"}, {
        "v": "469023",
        "n": "澄迈县"
      }, {"v": "469024", "n": "临高县"}, {"v": "469025", "n": "白沙黎族自治县"}, {"v": "469026", "n": "昌江黎族自治县"}, {
        "v": "469027",
        "n": "乐东黎族自治县"
      }, {"v": "469028", "n": "陵水黎族自治县"}, {"v": "469029", "n": "保亭黎族苗族自治县"}, {"v": "469030", "n": "琼中黎族苗族自治县"}]
    }]
  }, {
    "v": "500000",
    "n": "重庆市",
    "c": [{
      "v": "500100",
      "n": "重庆市",
      "c": [{"v": "500101", "n": "万州区"}, {"v": "500102", "n": "涪陵区"}, {"v": "500103", "n": "渝中区"}, {
        "v": "500104",
        "n": "大渡口区"
      }, {"v": "500105", "n": "江北区"}, {"v": "500106", "n": "沙坪坝区"}, {"v": "500107", "n": "九龙坡区"}, {
        "v": "500108",
        "n": "南岸区"
      }, {"v": "500109", "n": "北碚区"}, {"v": "500110", "n": "綦江区"}, {"v": "500111", "n": "大足区"}, {
        "v": "500112",
        "n": "渝北区"
      }, {"v": "500113", "n": "巴南区"}, {"v": "500114", "n": "黔江区"}, {"v": "500115", "n": "长寿区"}, {
        "v": "500116",
        "n": "江津区"
      }, {"v": "500117", "n": "合川区"}, {"v": "500118", "n": "永川区"}, {"v": "500119", "n": "南川区"}, {
        "v": "500120",
        "n": "璧山区"
      }, {"v": "500151", "n": "铜梁区"}, {"v": "500152", "n": "潼南区"}, {"v": "500153", "n": "荣昌区"}, {
        "v": "500154",
        "n": "开州区"
      }, {"v": "500155", "n": "梁平区"}, {"v": "500156", "n": "武隆区"}]
    }]
  }, {
    "v": "510000",
    "n": "四川省",
    "c": [{
      "v": "510100",
      "n": "成都市",
      "c": [{"v": "510104", "n": "锦江区"}, {"v": "510105", "n": "青羊区"}, {"v": "510106", "n": "金牛区"}, {
        "v": "510107",
        "n": "武侯区"
      }, {"v": "510108", "n": "成华区"}, {"v": "510112", "n": "龙泉驿区"}, {"v": "510113", "n": "青白江区"}, {
        "v": "510114",
        "n": "新都区"
      }, {"v": "510115", "n": "温江区"}, {"v": "510116", "n": "双流区"}, {"v": "510117", "n": "郫都区"}, {
        "v": "510121",
        "n": "金堂县"
      }, {"v": "510129", "n": "大邑县"}, {"v": "510131", "n": "蒲江县"}, {"v": "510132", "n": "新津县"}, {
        "v": "510181",
        "n": "都江堰市"
      }, {"v": "510182", "n": "彭州市"}, {"v": "510183", "n": "邛崃市"}, {"v": "510184", "n": "崇州市"}, {
        "v": "510185",
        "n": "简阳市"
      }]
    }, {
      "v": "510300",
      "n": "自贡市",
      "c": [{"v": "510302", "n": "自流井区"}, {"v": "510303", "n": "贡井区"}, {"v": "510304", "n": "大安区"}, {
        "v": "510311",
        "n": "沿滩区"
      }, {"v": "510321", "n": "荣县"}, {"v": "510322", "n": "富顺县"}]
    }, {
      "v": "510400",
      "n": "攀枝花市",
      "c": [{"v": "510402", "n": "东区"}, {"v": "510403", "n": "西区"}, {"v": "510411", "n": "仁和区"}, {
        "v": "510421",
        "n": "米易县"
      }, {"v": "510422", "n": "盐边县"}]
    }, {
      "v": "510500",
      "n": "泸州市",
      "c": [{"v": "510502", "n": "江阳区"}, {"v": "510503", "n": "纳溪区"}, {"v": "510504", "n": "龙马潭区"}, {
        "v": "510521",
        "n": "泸县"
      }, {"v": "510522", "n": "合江县"}, {"v": "510524", "n": "叙永县"}, {"v": "510525", "n": "古蔺县"}]
    }, {
      "v": "510600",
      "n": "德阳市",
      "c": [{"v": "510603", "n": "旌阳区"}, {"v": "510604", "n": "罗江区"}, {"v": "510623", "n": "中江县"}, {
        "v": "510681",
        "n": "广汉市"
      }, {"v": "510682", "n": "什邡市"}, {"v": "510683", "n": "绵竹市"}]
    }, {
      "v": "510700",
      "n": "绵阳市",
      "c": [{"v": "510703", "n": "涪城区"}, {"v": "510704", "n": "游仙区"}, {"v": "510705", "n": "安州区"}, {
        "v": "510722",
        "n": "三台县"
      }, {"v": "510723", "n": "盐亭县"}, {"v": "510725", "n": "梓潼县"}, {"v": "510726", "n": "北川羌族自治县"}, {
        "v": "510727",
        "n": "平武县"
      }, {"v": "510781", "n": "江油市"}]
    }, {
      "v": "510800",
      "n": "广元市",
      "c": [{"v": "510802", "n": "利州区"}, {"v": "510811", "n": "昭化区"}, {"v": "510812", "n": "朝天区"}, {
        "v": "510821",
        "n": "旺苍县"
      }, {"v": "510822", "n": "青川县"}, {"v": "510823", "n": "剑阁县"}, {"v": "510824", "n": "苍溪县"}]
    }, {
      "v": "510900",
      "n": "遂宁市",
      "c": [{"v": "510903", "n": "船山区"}, {"v": "510904", "n": "安居区"}, {"v": "510921", "n": "蓬溪县"}, {
        "v": "510923",
        "n": "大英县"
      }, {"v": "510981", "n": "射洪市"}]
    }, {
      "v": "511000",
      "n": "内江市",
      "c": [{"v": "511002", "n": "市中区"}, {"v": "511011", "n": "东兴区"}, {"v": "511024", "n": "威远县"}, {
        "v": "511025",
        "n": "资中县"
      }, {"v": "511083", "n": "隆昌市"}]
    }, {
      "v": "511100",
      "n": "乐山市",
      "c": [{"v": "511102", "n": "市中区"}, {"v": "511111", "n": "沙湾区"}, {"v": "511112", "n": "五通桥区"}, {
        "v": "511113",
        "n": "金口河区"
      }, {"v": "511123", "n": "犍为县"}, {"v": "511124", "n": "井研县"}, {"v": "511126", "n": "夹江县"}, {
        "v": "511129",
        "n": "沐川县"
      }, {"v": "511132", "n": "峨边彝族自治县"}, {"v": "511133", "n": "马边彝族自治县"}, {"v": "511181", "n": "峨眉山市"}]
    }, {
      "v": "511300",
      "n": "南充市",
      "c": [{"v": "511302", "n": "顺庆区"}, {"v": "511303", "n": "高坪区"}, {"v": "511304", "n": "嘉陵区"}, {
        "v": "511321",
        "n": "南部县"
      }, {"v": "511322", "n": "营山县"}, {"v": "511323", "n": "蓬安县"}, {"v": "511324", "n": "仪陇县"}, {
        "v": "511325",
        "n": "西充县"
      }, {"v": "511381", "n": "阆中市"}]
    }, {
      "v": "511400",
      "n": "眉山市",
      "c": [{"v": "511402", "n": "东坡区"}, {"v": "511403", "n": "彭山区"}, {"v": "511421", "n": "仁寿县"}, {
        "v": "511423",
        "n": "洪雅县"
      }, {"v": "511424", "n": "丹棱县"}, {"v": "511425", "n": "青神县"}]
    }, {
      "v": "511500",
      "n": "宜宾市",
      "c": [{"v": "511502", "n": "翠屏区"}, {"v": "511503", "n": "南溪区"}, {"v": "511504", "n": "叙州区"}, {
        "v": "511523",
        "n": "江安县"
      }, {"v": "511524", "n": "长宁县"}, {"v": "511525", "n": "高县"}, {"v": "511526", "n": "珙县"}, {
        "v": "511527",
        "n": "筠连县"
      }, {"v": "511528", "n": "兴文县"}, {"v": "511529", "n": "屏山县"}]
    }, {
      "v": "511600",
      "n": "广安市",
      "c": [{"v": "511602", "n": "广安区"}, {"v": "511603", "n": "前锋区"}, {"v": "511621", "n": "岳池县"}, {
        "v": "511622",
        "n": "武胜县"
      }, {"v": "511623", "n": "邻水县"}, {"v": "511681", "n": "华蓥市"}]
    }, {
      "v": "511700",
      "n": "达州市",
      "c": [{"v": "511702", "n": "通川区"}, {"v": "511703", "n": "达川区"}, {"v": "511722", "n": "宣汉县"}, {
        "v": "511723",
        "n": "开江县"
      }, {"v": "511724", "n": "大竹县"}, {"v": "511725", "n": "渠县"}, {"v": "511781", "n": "万源市"}]
    }, {
      "v": "511800",
      "n": "雅安市",
      "c": [{"v": "511802", "n": "雨城区"}, {"v": "511803", "n": "名山区"}, {"v": "511822", "n": "荥经县"}, {
        "v": "511823",
        "n": "汉源县"
      }, {"v": "511824", "n": "石棉县"}, {"v": "511825", "n": "天全县"}, {"v": "511826", "n": "芦山县"}, {
        "v": "511827",
        "n": "宝兴县"
      }]
    }, {
      "v": "511900",
      "n": "巴中市",
      "c": [{"v": "511902", "n": "巴州区"}, {"v": "511903", "n": "恩阳区"}, {"v": "511921", "n": "通江县"}, {
        "v": "511922",
        "n": "南江县"
      }, {"v": "511923", "n": "平昌县"}]
    }, {
      "v": "512000",
      "n": "资阳市",
      "c": [{"v": "512002", "n": "雁江区"}, {"v": "512021", "n": "安岳县"}, {"v": "512022", "n": "乐至县"}]
    }, {
      "v": "513200",
      "n": "阿坝藏族羌族自治州",
      "c": [{"v": "513201", "n": "马尔康市"}, {"v": "513221", "n": "汶川县"}, {"v": "513222", "n": "理县"}, {
        "v": "513223",
        "n": "茂县"
      }, {"v": "513224", "n": "松潘县"}, {"v": "513225", "n": "九寨沟县"}, {"v": "513226", "n": "金川县"}, {
        "v": "513227",
        "n": "小金县"
      }, {"v": "513228", "n": "黑水县"}, {"v": "513230", "n": "壤塘县"}, {"v": "513231", "n": "阿坝县"}, {
        "v": "513232",
        "n": "若尔盖县"
      }, {"v": "513233", "n": "红原县"}]
    }, {
      "v": "513300",
      "n": "甘孜藏族自治州",
      "c": [{"v": "513301", "n": "康定市"}, {"v": "513322", "n": "泸定县"}, {"v": "513323", "n": "丹巴县"}, {
        "v": "513324",
        "n": "九龙县"
      }, {"v": "513325", "n": "雅江县"}, {"v": "513326", "n": "道孚县"}, {"v": "513327", "n": "炉霍县"}, {
        "v": "513328",
        "n": "甘孜县"
      }, {"v": "513329", "n": "新龙县"}, {"v": "513330", "n": "德格县"}, {"v": "513331", "n": "白玉县"}, {
        "v": "513332",
        "n": "石渠县"
      }, {"v": "513333", "n": "色达县"}, {"v": "513334", "n": "理塘县"}, {"v": "513335", "n": "巴塘县"}, {
        "v": "513336",
        "n": "乡城县"
      }, {"v": "513337", "n": "稻城县"}, {"v": "513338", "n": "得荣县"}]
    }, {
      "v": "513400",
      "n": "凉山彝族自治州",
      "c": [{"v": "513401", "n": "西昌市"}, {"v": "513422", "n": "木里藏族自治县"}, {"v": "513423", "n": "盐源县"}, {
        "v": "513424",
        "n": "德昌县"
      }, {"v": "513425", "n": "会理县"}, {"v": "513426", "n": "会东县"}, {"v": "513427", "n": "宁南县"}, {
        "v": "513428",
        "n": "普格县"
      }, {"v": "513429", "n": "布拖县"}, {"v": "513430", "n": "金阳县"}, {"v": "513431", "n": "昭觉县"}, {
        "v": "513432",
        "n": "喜德县"
      }, {"v": "513433", "n": "冕宁县"}, {"v": "513434", "n": "越西县"}, {"v": "513435", "n": "甘洛县"}, {
        "v": "513436",
        "n": "美姑县"
      }, {"v": "513437", "n": "雷波县"}]
    }]
  }, {
    "v": "520000",
    "n": "贵州省",
    "c": [{
      "v": "520100",
      "n": "贵阳市",
      "c": [{"v": "520102", "n": "南明区"}, {"v": "520103", "n": "云岩区"}, {"v": "520111", "n": "花溪区"}, {
        "v": "520112",
        "n": "乌当区"
      }, {"v": "520113", "n": "白云区"}, {"v": "520115", "n": "观山湖区"}, {"v": "520121", "n": "开阳县"}, {
        "v": "520122",
        "n": "息烽县"
      }, {"v": "520123", "n": "修文县"}, {"v": "520181", "n": "清镇市"}]
    }, {
      "v": "520200",
      "n": "六盘水市",
      "c": [{"v": "520201", "n": "钟山区"}, {"v": "520203", "n": "六枝特区"}, {"v": "520221", "n": "水城县"}, {
        "v": "520281",
        "n": "盘州市"
      }]
    }, {
      "v": "520300",
      "n": "遵义市",
      "c": [{"v": "520302", "n": "红花岗区"}, {"v": "520303", "n": "汇川区"}, {"v": "520304", "n": "播州区"}, {
        "v": "520322",
        "n": "桐梓县"
      }, {"v": "520323", "n": "绥阳县"}, {"v": "520324", "n": "正安县"}, {"v": "520325", "n": "道真仡佬族苗族自治县"}, {
        "v": "520326",
        "n": "务川仡佬族苗族自治县"
      }, {"v": "520327", "n": "凤冈县"}, {"v": "520328", "n": "湄潭县"}, {"v": "520329", "n": "余庆县"}, {
        "v": "520330",
        "n": "习水县"
      }, {"v": "520381", "n": "赤水市"}, {"v": "520382", "n": "仁怀市"}]
    }, {
      "v": "520400",
      "n": "安顺市",
      "c": [{"v": "520402", "n": "西秀区"}, {"v": "520403", "n": "平坝区"}, {"v": "520422", "n": "普定县"}, {
        "v": "520423",
        "n": "镇宁布依族苗族自治县"
      }, {"v": "520424", "n": "关岭布依族苗族自治县"}, {"v": "520425", "n": "紫云苗族布依族自治县"}]
    }, {
      "v": "520500",
      "n": "毕节市",
      "c": [{"v": "520502", "n": "七星关区"}, {"v": "520521", "n": "大方县"}, {"v": "520522", "n": "黔西县"}, {
        "v": "520523",
        "n": "金沙县"
      }, {"v": "520524", "n": "织金县"}, {"v": "520525", "n": "纳雍县"}, {"v": "520526", "n": "威宁彝族回族苗族自治县"}, {
        "v": "520527",
        "n": "赫章县"
      }]
    }, {
      "v": "520600",
      "n": "铜仁市",
      "c": [{"v": "520602", "n": "碧江区"}, {"v": "520603", "n": "万山区"}, {"v": "520621", "n": "江口县"}, {
        "v": "520622",
        "n": "玉屏侗族自治县"
      }, {"v": "520623", "n": "石阡县"}, {"v": "520624", "n": "思南县"}, {"v": "520625", "n": "印江土家族苗族自治县"}, {
        "v": "520626",
        "n": "德江县"
      }, {"v": "520627", "n": "沿河土家族自治县"}, {"v": "520628", "n": "松桃苗族自治县"}]
    }, {
      "v": "522300",
      "n": "黔西南布依族苗族自治州",
      "c": [{"v": "522301", "n": "兴义市"}, {"v": "522302", "n": "兴仁市"}, {"v": "522323", "n": "普安县"}, {
        "v": "522324",
        "n": "晴隆县"
      }, {"v": "522325", "n": "贞丰县"}, {"v": "522326", "n": "望谟县"}, {"v": "522327", "n": "册亨县"}, {
        "v": "522328",
        "n": "安龙县"
      }]
    }, {
      "v": "522600",
      "n": "黔东南苗族侗族自治州",
      "c": [{"v": "522601", "n": "凯里市"}, {"v": "522622", "n": "黄平县"}, {"v": "522623", "n": "施秉县"}, {
        "v": "522624",
        "n": "三穗县"
      }, {"v": "522625", "n": "镇远县"}, {"v": "522626", "n": "岑巩县"}, {"v": "522627", "n": "天柱县"}, {
        "v": "522628",
        "n": "锦屏县"
      }, {"v": "522629", "n": "剑河县"}, {"v": "522630", "n": "台江县"}, {"v": "522631", "n": "黎平县"}, {
        "v": "522632",
        "n": "榕江县"
      }, {"v": "522633", "n": "从江县"}, {"v": "522634", "n": "雷山县"}, {"v": "522635", "n": "麻江县"}, {
        "v": "522636",
        "n": "丹寨县"
      }]
    }, {
      "v": "522700",
      "n": "黔南布依族苗族自治州",
      "c": [{"v": "522701", "n": "都匀市"}, {"v": "522702", "n": "福泉市"}, {"v": "522722", "n": "荔波县"}, {
        "v": "522723",
        "n": "贵定县"
      }, {"v": "522725", "n": "瓮安县"}, {"v": "522726", "n": "独山县"}, {"v": "522727", "n": "平塘县"}, {
        "v": "522728",
        "n": "罗甸县"
      }, {"v": "522729", "n": "长顺县"}, {"v": "522730", "n": "龙里县"}, {"v": "522731", "n": "惠水县"}, {
        "v": "522732",
        "n": "三都水族自治县"
      }]
    }]
  }, {
    "v": "530000",
    "n": "云南省",
    "c": [{
      "v": "530100",
      "n": "昆明市",
      "c": [{"v": "530102", "n": "五华区"}, {"v": "530103", "n": "盘龙区"}, {"v": "530111", "n": "官渡区"}, {
        "v": "530112",
        "n": "西山区"
      }, {"v": "530113", "n": "东川区"}, {"v": "530114", "n": "呈贡区"}, {"v": "530115", "n": "晋宁区"}, {
        "v": "530124",
        "n": "富民县"
      }, {"v": "530125", "n": "宜良县"}, {"v": "530126", "n": "石林彝族自治县"}, {"v": "530127", "n": "嵩明县"}, {
        "v": "530128",
        "n": "禄劝彝族苗族自治县"
      }, {"v": "530129", "n": "寻甸回族彝族自治县"}, {"v": "530181", "n": "安宁市"}]
    }, {
      "v": "530300",
      "n": "曲靖市",
      "c": [{"v": "530302", "n": "麒麟区"}, {"v": "530303", "n": "沾益区"}, {"v": "530304", "n": "马龙区"}, {
        "v": "530322",
        "n": "陆良县"
      }, {"v": "530323", "n": "师宗县"}, {"v": "530324", "n": "罗平县"}, {"v": "530325", "n": "富源县"}, {
        "v": "530326",
        "n": "会泽县"
      }, {"v": "530381", "n": "宣威市"}]
    }, {
      "v": "530400",
      "n": "玉溪市",
      "c": [{"v": "530402", "n": "红塔区"}, {"v": "530403", "n": "江川区"}, {"v": "530423", "n": "通海县"}, {
        "v": "530424",
        "n": "华宁县"
      }, {"v": "530425", "n": "易门县"}, {"v": "530426", "n": "峨山彝族自治县"}, {
        "v": "530427",
        "n": "新平彝族傣族自治县"
      }, {"v": "530428", "n": "元江哈尼族彝族傣族自治县"}, {"v": "530481", "n": "澄江市"}]
    }, {
      "v": "530500",
      "n": "保山市",
      "c": [{"v": "530502", "n": "隆阳区"}, {"v": "530521", "n": "施甸县"}, {"v": "530523", "n": "龙陵县"}, {
        "v": "530524",
        "n": "昌宁县"
      }, {"v": "530581", "n": "腾冲市"}]
    }, {
      "v": "530600",
      "n": "昭通市",
      "c": [{"v": "530602", "n": "昭阳区"}, {"v": "530621", "n": "鲁甸县"}, {"v": "530622", "n": "巧家县"}, {
        "v": "530623",
        "n": "盐津县"
      }, {"v": "530624", "n": "大关县"}, {"v": "530625", "n": "永善县"}, {"v": "530626", "n": "绥江县"}, {
        "v": "530627",
        "n": "镇雄县"
      }, {"v": "530628", "n": "彝良县"}, {"v": "530629", "n": "威信县"}, {"v": "530681", "n": "水富市"}]
    }, {
      "v": "530700",
      "n": "丽江市",
      "c": [{"v": "530702", "n": "古城区"}, {"v": "530721", "n": "玉龙纳西族自治县"}, {"v": "530722", "n": "永胜县"}, {
        "v": "530723",
        "n": "华坪县"
      }, {"v": "530724", "n": "宁蒗彝族自治县"}]
    }, {
      "v": "530800",
      "n": "普洱市",
      "c": [{"v": "530802", "n": "思茅区"}, {"v": "530821", "n": "宁洱哈尼族彝族自治县"}, {
        "v": "530822",
        "n": "墨江哈尼族自治县"
      }, {"v": "530823", "n": "景东彝族自治县"}, {"v": "530824", "n": "景谷傣族彝族自治县"}, {
        "v": "530825",
        "n": "镇沅彝族哈尼族拉祜族自治县"
      }, {"v": "530826", "n": "江城哈尼族彝族自治县"}, {"v": "530827", "n": "孟连傣族拉祜族佤族自治县"}, {
        "v": "530828",
        "n": "澜沧拉祜族自治县"
      }, {"v": "530829", "n": "西盟佤族自治县"}]
    }, {
      "v": "530900",
      "n": "临沧市",
      "c": [{"v": "530902", "n": "临翔区"}, {"v": "530921", "n": "凤庆县"}, {"v": "530922", "n": "云县"}, {
        "v": "530923",
        "n": "永德县"
      }, {"v": "530924", "n": "镇康县"}, {"v": "530925", "n": "双江拉祜族佤族布朗族傣族自治县"}, {
        "v": "530926",
        "n": "耿马傣族佤族自治县"
      }, {"v": "530927", "n": "沧源佤族自治县"}]
    }, {
      "v": "532300",
      "n": "楚雄彝族自治州",
      "c": [{"v": "532301", "n": "楚雄市"}, {"v": "532322", "n": "双柏县"}, {"v": "532323", "n": "牟定县"}, {
        "v": "532324",
        "n": "南华县"
      }, {"v": "532325", "n": "姚安县"}, {"v": "532326", "n": "大姚县"}, {"v": "532327", "n": "永仁县"}, {
        "v": "532328",
        "n": "元谋县"
      }, {"v": "532329", "n": "武定县"}, {"v": "532331", "n": "禄丰县"}]
    }, {
      "v": "532500",
      "n": "红河哈尼族彝族自治州",
      "c": [{"v": "532501", "n": "个旧市"}, {"v": "532502", "n": "开远市"}, {"v": "532503", "n": "蒙自市"}, {
        "v": "532504",
        "n": "弥勒市"
      }, {"v": "532523", "n": "屏边苗族自治县"}, {"v": "532524", "n": "建水县"}, {"v": "532525", "n": "石屏县"}, {
        "v": "532527",
        "n": "泸西县"
      }, {"v": "532528", "n": "元阳县"}, {"v": "532529", "n": "红河县"}, {"v": "532530", "n": "金平苗族瑶族傣族自治县"}, {
        "v": "532531",
        "n": "绿春县"
      }, {"v": "532532", "n": "河口瑶族自治县"}]
    }, {
      "v": "532600",
      "n": "文山壮族苗族自治州",
      "c": [{"v": "532601", "n": "文山市"}, {"v": "532622", "n": "砚山县"}, {"v": "532623", "n": "西畴县"}, {
        "v": "532624",
        "n": "麻栗坡县"
      }, {"v": "532625", "n": "马关县"}, {"v": "532626", "n": "丘北县"}, {"v": "532627", "n": "广南县"}, {
        "v": "532628",
        "n": "富宁县"
      }]
    }, {
      "v": "532800",
      "n": "西双版纳傣族自治州",
      "c": [{"v": "532801", "n": "景洪市"}, {"v": "532822", "n": "勐海县"}, {"v": "532823", "n": "勐腊县"}]
    }, {
      "v": "532900",
      "n": "大理白族自治州",
      "c": [{"v": "532901", "n": "大理市"}, {"v": "532922", "n": "漾濞彝族自治县"}, {"v": "532923", "n": "祥云县"}, {
        "v": "532924",
        "n": "宾川县"
      }, {"v": "532925", "n": "弥渡县"}, {"v": "532926", "n": "南涧彝族自治县"}, {
        "v": "532927",
        "n": "巍山彝族回族自治县"
      }, {"v": "532928", "n": "永平县"}, {"v": "532929", "n": "云龙县"}, {"v": "532930", "n": "洱源县"}, {
        "v": "532931",
        "n": "剑川县"
      }, {"v": "532932", "n": "鹤庆县"}]
    }, {
      "v": "533100",
      "n": "德宏傣族景颇族自治州",
      "c": [{"v": "533102", "n": "瑞丽市"}, {"v": "533103", "n": "芒市"}, {"v": "533122", "n": "梁河县"}, {
        "v": "533123",
        "n": "盈江县"
      }, {"v": "533124", "n": "陇川县"}]
    }, {
      "v": "533300",
      "n": "怒江傈僳族自治州",
      "c": [{"v": "533301", "n": "泸水市"}, {"v": "533323", "n": "福贡县"}, {
        "v": "533324",
        "n": "贡山独龙族怒族自治县"
      }, {"v": "533325", "n": "兰坪白族普米族自治县"}]
    }, {
      "v": "533400",
      "n": "迪庆藏族自治州",
      "c": [{"v": "533401", "n": "香格里拉市"}, {"v": "533422", "n": "德钦县"}, {"v": "533423", "n": "维西傈僳族自治县"}]
    }]
  }, {
    "v": "540000",
    "n": "西藏自治区",
    "c": [{
      "v": "540100",
      "n": "拉萨市",
      "c": [{"v": "540102", "n": "城关区"}, {"v": "540103", "n": "堆龙德庆区"}, {"v": "540104", "n": "达孜区"}, {
        "v": "540121",
        "n": "林周县"
      }, {"v": "540122", "n": "当雄县"}, {"v": "540123", "n": "尼木县"}, {"v": "540124", "n": "曲水县"}, {
        "v": "540127",
        "n": "墨竹工卡县"
      }]
    }, {
      "v": "540200",
      "n": "日喀则市",
      "c": [{"v": "540202", "n": "桑珠孜区"}, {"v": "540221", "n": "南木林县"}, {"v": "540222", "n": "江孜县"}, {
        "v": "540223",
        "n": "定日县"
      }, {"v": "540224", "n": "萨迦县"}, {"v": "540225", "n": "拉孜县"}, {"v": "540226", "n": "昂仁县"}, {
        "v": "540227",
        "n": "谢通门县"
      }, {"v": "540228", "n": "白朗县"}, {"v": "540229", "n": "仁布县"}, {"v": "540230", "n": "康马县"}, {
        "v": "540231",
        "n": "定结县"
      }, {"v": "540232", "n": "仲巴县"}, {"v": "540233", "n": "亚东县"}, {"v": "540234", "n": "吉隆县"}, {
        "v": "540235",
        "n": "聂拉木县"
      }, {"v": "540236", "n": "萨嘎县"}, {"v": "540237", "n": "岗巴县"}]
    }, {
      "v": "540300",
      "n": "昌都市",
      "c": [{"v": "540302", "n": "卡若区"}, {"v": "540321", "n": "江达县"}, {"v": "540322", "n": "贡觉县"}, {
        "v": "540323",
        "n": "类乌齐县"
      }, {"v": "540324", "n": "丁青县"}, {"v": "540325", "n": "察雅县"}, {"v": "540326", "n": "八宿县"}, {
        "v": "540327",
        "n": "左贡县"
      }, {"v": "540328", "n": "芒康县"}, {"v": "540329", "n": "洛隆县"}, {"v": "540330", "n": "边坝县"}]
    }, {
      "v": "540400",
      "n": "林芝市",
      "c": [{"v": "540402", "n": "巴宜区"}, {"v": "540421", "n": "工布江达县"}, {"v": "540422", "n": "米林县"}, {
        "v": "540423",
        "n": "墨脱县"
      }, {"v": "540424", "n": "波密县"}, {"v": "540425", "n": "察隅县"}, {"v": "540426", "n": "朗县"}]
    }, {
      "v": "540500",
      "n": "山南市",
      "c": [{"v": "540502", "n": "乃东区"}, {"v": "540521", "n": "扎囊县"}, {"v": "540522", "n": "贡嘎县"}, {
        "v": "540523",
        "n": "桑日县"
      }, {"v": "540524", "n": "琼结县"}, {"v": "540525", "n": "曲松县"}, {"v": "540526", "n": "措美县"}, {
        "v": "540527",
        "n": "洛扎县"
      }, {"v": "540528", "n": "加查县"}, {"v": "540529", "n": "隆子县"}, {"v": "540530", "n": "错那县"}, {
        "v": "540531",
        "n": "浪卡子县"
      }]
    }, {
      "v": "540600",
      "n": "那曲市",
      "c": [{"v": "540602", "n": "色尼区"}, {"v": "540621", "n": "嘉黎县"}, {"v": "540622", "n": "比如县"}, {
        "v": "540623",
        "n": "聂荣县"
      }, {"v": "540624", "n": "安多县"}, {"v": "540625", "n": "申扎县"}, {"v": "540626", "n": "索县"}, {
        "v": "540627",
        "n": "班戈县"
      }, {"v": "540628", "n": "巴青县"}, {"v": "540629", "n": "尼玛县"}, {"v": "540630", "n": "双湖县"}]
    }, {
      "v": "542500",
      "n": "阿里地区",
      "c": [{"v": "542521", "n": "普兰县"}, {"v": "542522", "n": "札达县"}, {"v": "542523", "n": "噶尔县"}, {
        "v": "542524",
        "n": "日土县"
      }, {"v": "542525", "n": "革吉县"}, {"v": "542526", "n": "改则县"}, {"v": "542527", "n": "措勤县"}]
    }]
  }, {
    "v": "610000",
    "n": "陕西省",
    "c": [{
      "v": "610100",
      "n": "西安市",
      "c": [{"v": "610102", "n": "新城区"}, {"v": "610103", "n": "碑林区"}, {"v": "610104", "n": "莲湖区"}, {
        "v": "610111",
        "n": "灞桥区"
      }, {"v": "610112", "n": "未央区"}, {"v": "610113", "n": "雁塔区"}, {"v": "610114", "n": "阎良区"}, {
        "v": "610115",
        "n": "临潼区"
      }, {"v": "610116", "n": "长安区"}, {"v": "610117", "n": "高陵区"}, {"v": "610118", "n": "鄠邑区"}, {
        "v": "610122",
        "n": "蓝田县"
      }, {"v": "610124", "n": "周至县"}]
    }, {
      "v": "610200",
      "n": "铜川市",
      "c": [{"v": "610202", "n": "王益区"}, {"v": "610203", "n": "印台区"}, {"v": "610204", "n": "耀州区"}, {
        "v": "610222",
        "n": "宜君县"
      }]
    }, {
      "v": "610300",
      "n": "宝鸡市",
      "c": [{"v": "610302", "n": "渭滨区"}, {"v": "610303", "n": "金台区"}, {"v": "610304", "n": "陈仓区"}, {
        "v": "610322",
        "n": "凤翔县"
      }, {"v": "610323", "n": "岐山县"}, {"v": "610324", "n": "扶风县"}, {"v": "610326", "n": "眉县"}, {
        "v": "610327",
        "n": "陇县"
      }, {"v": "610328", "n": "千阳县"}, {"v": "610329", "n": "麟游县"}, {"v": "610330", "n": "凤县"}, {
        "v": "610331",
        "n": "太白县"
      }]
    }, {
      "v": "610400",
      "n": "咸阳市",
      "c": [{"v": "610402", "n": "秦都区"}, {"v": "610403", "n": "杨陵区"}, {"v": "610404", "n": "渭城区"}, {
        "v": "610422",
        "n": "三原县"
      }, {"v": "610423", "n": "泾阳县"}, {"v": "610424", "n": "乾县"}, {"v": "610425", "n": "礼泉县"}, {
        "v": "610426",
        "n": "永寿县"
      }, {"v": "610428", "n": "长武县"}, {"v": "610429", "n": "旬邑县"}, {"v": "610430", "n": "淳化县"}, {
        "v": "610431",
        "n": "武功县"
      }, {"v": "610481", "n": "兴平市"}, {"v": "610482", "n": "彬州市"}]
    }, {
      "v": "610500",
      "n": "渭南市",
      "c": [{"v": "610502", "n": "临渭区"}, {"v": "610503", "n": "华州区"}, {"v": "610522", "n": "潼关县"}, {
        "v": "610523",
        "n": "大荔县"
      }, {"v": "610524", "n": "合阳县"}, {"v": "610525", "n": "澄城县"}, {"v": "610526", "n": "蒲城县"}, {
        "v": "610527",
        "n": "白水县"
      }, {"v": "610528", "n": "富平县"}, {"v": "610581", "n": "韩城市"}, {"v": "610582", "n": "华阴市"}]
    }, {
      "v": "610600",
      "n": "延安市",
      "c": [{"v": "610602", "n": "宝塔区"}, {"v": "610603", "n": "安塞区"}, {"v": "610621", "n": "延长县"}, {
        "v": "610622",
        "n": "延川县"
      }, {"v": "610625", "n": "志丹县"}, {"v": "610626", "n": "吴起县"}, {"v": "610627", "n": "甘泉县"}, {
        "v": "610628",
        "n": "富县"
      }, {"v": "610629", "n": "洛川县"}, {"v": "610630", "n": "宜川县"}, {"v": "610631", "n": "黄龙县"}, {
        "v": "610632",
        "n": "黄陵县"
      }, {"v": "610681", "n": "子长市"}]
    }, {
      "v": "610700",
      "n": "汉中市",
      "c": [{"v": "610702", "n": "汉台区"}, {"v": "610703", "n": "南郑区"}, {"v": "610722", "n": "城固县"}, {
        "v": "610723",
        "n": "洋县"
      }, {"v": "610724", "n": "西乡县"}, {"v": "610725", "n": "勉县"}, {"v": "610726", "n": "宁强县"}, {
        "v": "610727",
        "n": "略阳县"
      }, {"v": "610728", "n": "镇巴县"}, {"v": "610729", "n": "留坝县"}, {"v": "610730", "n": "佛坪县"}]
    }, {
      "v": "610800",
      "n": "榆林市",
      "c": [{"v": "610802", "n": "榆阳区"}, {"v": "610803", "n": "横山区"}, {"v": "610822", "n": "府谷县"}, {
        "v": "610824",
        "n": "靖边县"
      }, {"v": "610825", "n": "定边县"}, {"v": "610826", "n": "绥德县"}, {"v": "610827", "n": "米脂县"}, {
        "v": "610828",
        "n": "佳县"
      }, {"v": "610829", "n": "吴堡县"}, {"v": "610830", "n": "清涧县"}, {"v": "610831", "n": "子洲县"}, {
        "v": "610881",
        "n": "神木市"
      }]
    }, {
      "v": "610900",
      "n": "安康市",
      "c": [{"v": "610902", "n": "汉滨区"}, {"v": "610921", "n": "汉阴县"}, {"v": "610922", "n": "石泉县"}, {
        "v": "610923",
        "n": "宁陕县"
      }, {"v": "610924", "n": "紫阳县"}, {"v": "610925", "n": "岚皋县"}, {"v": "610926", "n": "平利县"}, {
        "v": "610927",
        "n": "镇坪县"
      }, {"v": "610928", "n": "旬阳县"}, {"v": "610929", "n": "白河县"}]
    }, {
      "v": "611000",
      "n": "商洛市",
      "c": [{"v": "611002", "n": "商州区"}, {"v": "611021", "n": "洛南县"}, {"v": "611022", "n": "丹凤县"}, {
        "v": "611023",
        "n": "商南县"
      }, {"v": "611024", "n": "山阳县"}, {"v": "611025", "n": "镇安县"}, {"v": "611026", "n": "柞水县"}]
    }]
  }, {
    "v": "620000",
    "n": "甘肃省",
    "c": [{
      "v": "620100",
      "n": "兰州市",
      "c": [{"v": "620102", "n": "城关区"}, {"v": "620103", "n": "七里河区"}, {"v": "620104", "n": "西固区"}, {
        "v": "620105",
        "n": "安宁区"
      }, {"v": "620111", "n": "红古区"}, {"v": "620121", "n": "永登县"}, {"v": "620122", "n": "皋兰县"}, {
        "v": "620123",
        "n": "榆中县"
      }]
    }, {"v": "620200", "n": "嘉峪关市", "c": [{"v": "620201", "n": "市辖区"}]}, {
      "v": "620300",
      "n": "金昌市",
      "c": [{"v": "620302", "n": "金川区"}, {"v": "620321", "n": "永昌县"}]
    }, {
      "v": "620400",
      "n": "白银市",
      "c": [{"v": "620402", "n": "白银区"}, {"v": "620403", "n": "平川区"}, {"v": "620421", "n": "靖远县"}, {
        "v": "620422",
        "n": "会宁县"
      }, {"v": "620423", "n": "景泰县"}]
    }, {
      "v": "620500",
      "n": "天水市",
      "c": [{"v": "620502", "n": "秦州区"}, {"v": "620503", "n": "麦积区"}, {"v": "620521", "n": "清水县"}, {
        "v": "620522",
        "n": "秦安县"
      }, {"v": "620523", "n": "甘谷县"}, {"v": "620524", "n": "武山县"}, {"v": "620525", "n": "张家川回族自治县"}]
    }, {
      "v": "620600",
      "n": "武威市",
      "c": [{"v": "620602", "n": "凉州区"}, {"v": "620621", "n": "民勤县"}, {"v": "620622", "n": "古浪县"}, {
        "v": "620623",
        "n": "天祝藏族自治县"
      }]
    }, {
      "v": "620700",
      "n": "张掖市",
      "c": [{"v": "620702", "n": "甘州区"}, {"v": "620721", "n": "肃南裕固族自治县"}, {"v": "620722", "n": "民乐县"}, {
        "v": "620723",
        "n": "临泽县"
      }, {"v": "620724", "n": "高台县"}, {"v": "620725", "n": "山丹县"}]
    }, {
      "v": "620800",
      "n": "平凉市",
      "c": [{"v": "620802", "n": "崆峒区"}, {"v": "620821", "n": "泾川县"}, {"v": "620822", "n": "灵台县"}, {
        "v": "620823",
        "n": "崇信县"
      }, {"v": "620825", "n": "庄浪县"}, {"v": "620826", "n": "静宁县"}, {"v": "620881", "n": "华亭市"}]
    }, {
      "v": "620900",
      "n": "酒泉市",
      "c": [{"v": "620902", "n": "肃州区"}, {"v": "620921", "n": "金塔县"}, {"v": "620922", "n": "瓜州县"}, {
        "v": "620923",
        "n": "肃北蒙古族自治县"
      }, {"v": "620924", "n": "阿克塞哈萨克族自治县"}, {"v": "620981", "n": "玉门市"}, {"v": "620982", "n": "敦煌市"}]
    }, {
      "v": "621000",
      "n": "庆阳市",
      "c": [{"v": "621002", "n": "西峰区"}, {"v": "621021", "n": "庆城县"}, {"v": "621022", "n": "环县"}, {
        "v": "621023",
        "n": "华池县"
      }, {"v": "621024", "n": "合水县"}, {"v": "621025", "n": "正宁县"}, {"v": "621026", "n": "宁县"}, {
        "v": "621027",
        "n": "镇原县"
      }]
    }, {
      "v": "621100",
      "n": "定西市",
      "c": [{"v": "621102", "n": "安定区"}, {"v": "621121", "n": "通渭县"}, {"v": "621122", "n": "陇西县"}, {
        "v": "621123",
        "n": "渭源县"
      }, {"v": "621124", "n": "临洮县"}, {"v": "621125", "n": "漳县"}, {"v": "621126", "n": "岷县"}]
    }, {
      "v": "621200",
      "n": "陇南市",
      "c": [{"v": "621202", "n": "武都区"}, {"v": "621221", "n": "成县"}, {"v": "621222", "n": "文县"}, {
        "v": "621223",
        "n": "宕昌县"
      }, {"v": "621224", "n": "康县"}, {"v": "621225", "n": "西和县"}, {"v": "621226", "n": "礼县"}, {
        "v": "621227",
        "n": "徽县"
      }, {"v": "621228", "n": "两当县"}]
    }, {
      "v": "622900",
      "n": "临夏回族自治州",
      "c": [{"v": "622901", "n": "临夏市"}, {"v": "622921", "n": "临夏县"}, {"v": "622922", "n": "康乐县"}, {
        "v": "622923",
        "n": "永靖县"
      }, {"v": "622924", "n": "广河县"}, {"v": "622925", "n": "和政县"}, {"v": "622926", "n": "东乡族自治县"}, {
        "v": "622927",
        "n": "积石山保安族东乡族撒拉族自治县"
      }]
    }, {
      "v": "623000",
      "n": "甘南藏族自治州",
      "c": [{"v": "623001", "n": "合作市"}, {"v": "623021", "n": "临潭县"}, {"v": "623022", "n": "卓尼县"}, {
        "v": "623023",
        "n": "舟曲县"
      }, {"v": "623024", "n": "迭部县"}, {"v": "623025", "n": "玛曲县"}, {"v": "623026", "n": "碌曲县"}, {
        "v": "623027",
        "n": "夏河县"
      }]
    }]
  }, {
    "v": "630000",
    "n": "青海省",
    "c": [{
      "v": "630100",
      "n": "西宁市",
      "c": [{"v": "630102", "n": "城东区"}, {"v": "630103", "n": "城中区"}, {"v": "630104", "n": "城西区"}, {
        "v": "630105",
        "n": "城北区"
      }, {"v": "630106", "n": "湟中区"}, {"v": "630121", "n": "大通回族土族自治县"}, {"v": "630123", "n": "湟源县"}]
    }, {
      "v": "630200",
      "n": "海东市",
      "c": [{"v": "630202", "n": "乐都区"}, {"v": "630203", "n": "平安区"}, {"v": "630222", "n": "民和回族土族自治县"}, {
        "v": "630223",
        "n": "互助土族自治县"
      }, {"v": "630224", "n": "化隆回族自治县"}, {"v": "630225", "n": "循化撒拉族自治县"}]
    }, {
      "v": "632200",
      "n": "海北藏族自治州",
      "c": [{"v": "632221", "n": "门源回族自治县"}, {"v": "632222", "n": "祁连县"}, {"v": "632223", "n": "海晏县"}, {
        "v": "632224",
        "n": "刚察县"
      }]
    }, {
      "v": "632300",
      "n": "黄南藏族自治州",
      "c": [{"v": "632321", "n": "同仁县"}, {"v": "632322", "n": "尖扎县"}, {"v": "632323", "n": "泽库县"}, {
        "v": "632324",
        "n": "河南蒙古族自治县"
      }]
    }, {
      "v": "632500",
      "n": "海南藏族自治州",
      "c": [{"v": "632521", "n": "共和县"}, {"v": "632522", "n": "同德县"}, {"v": "632523", "n": "贵德县"}, {
        "v": "632524",
        "n": "兴海县"
      }, {"v": "632525", "n": "贵南县"}]
    }, {
      "v": "632600",
      "n": "果洛藏族自治州",
      "c": [{"v": "632621", "n": "玛沁县"}, {"v": "632622", "n": "班玛县"}, {"v": "632623", "n": "甘德县"}, {
        "v": "632624",
        "n": "达日县"
      }, {"v": "632625", "n": "久治县"}, {"v": "632626", "n": "玛多县"}]
    }, {
      "v": "632700",
      "n": "玉树藏族自治州",
      "c": [{"v": "632701", "n": "玉树市"}, {"v": "632722", "n": "杂多县"}, {"v": "632723", "n": "称多县"}, {
        "v": "632724",
        "n": "治多县"
      }, {"v": "632725", "n": "囊谦县"}, {"v": "632726", "n": "曲麻莱县"}]
    }, {
      "v": "632800",
      "n": "海西蒙古族藏族自治州",
      "c": [{"v": "632801", "n": "格尔木市"}, {"v": "632802", "n": "德令哈市"}, {"v": "632803", "n": "茫崖市"}, {
        "v": "632821",
        "n": "乌兰县"
      }, {"v": "632822", "n": "都兰县"}, {"v": "632823", "n": "天峻县"}]
    }]
  }, {
    "v": "640000",
    "n": "宁夏回族自治区",
    "c": [{
      "v": "640100",
      "n": "银川市",
      "c": [{"v": "640104", "n": "兴庆区"}, {"v": "640105", "n": "西夏区"}, {"v": "640106", "n": "金凤区"}, {
        "v": "640121",
        "n": "永宁县"
      }, {"v": "640122", "n": "贺兰县"}, {"v": "640181", "n": "灵武市"}]
    }, {
      "v": "640200",
      "n": "石嘴山市",
      "c": [{"v": "640202", "n": "大武口区"}, {"v": "640205", "n": "惠农区"}, {"v": "640221", "n": "平罗县"}]
    }, {
      "v": "640300",
      "n": "吴忠市",
      "c": [{"v": "640302", "n": "利通区"}, {"v": "640303", "n": "红寺堡区"}, {"v": "640323", "n": "盐池县"}, {
        "v": "640324",
        "n": "同心县"
      }, {"v": "640381", "n": "青铜峡市"}]
    }, {
      "v": "640400",
      "n": "固原市",
      "c": [{"v": "640402", "n": "原州区"}, {"v": "640422", "n": "西吉县"}, {"v": "640423", "n": "隆德县"}, {
        "v": "640424",
        "n": "泾源县"
      }, {"v": "640425", "n": "彭阳县"}]
    }, {
      "v": "640500",
      "n": "中卫市",
      "c": [{"v": "640502", "n": "沙坡头区"}, {"v": "640521", "n": "中宁县"}, {"v": "640522", "n": "海原县"}]
    }]
  }, {
    "v": "650000",
    "n": "新疆维吾尔自治区",
    "c": [{
      "v": "650100",
      "n": "乌鲁木齐市",
      "c": [{"v": "650102", "n": "天山区"}, {"v": "650103", "n": "沙依巴克区"}, {"v": "650104", "n": "新市区"}, {
        "v": "650105",
        "n": "水磨沟区"
      }, {"v": "650106", "n": "头屯河区"}, {"v": "650107", "n": "达坂城区"}, {"v": "650109", "n": "米东区"}, {
        "v": "650121",
        "n": "乌鲁木齐县"
      }]
    }, {
      "v": "650200",
      "n": "克拉玛依市",
      "c": [{"v": "650202", "n": "独山子区"}, {"v": "650203", "n": "克拉玛依区"}, {"v": "650204", "n": "白碱滩区"}, {
        "v": "650205",
        "n": "乌尔禾区"
      }]
    }, {
      "v": "650400",
      "n": "吐鲁番市",
      "c": [{"v": "650402", "n": "高昌区"}, {"v": "650421", "n": "鄯善县"}, {"v": "650422", "n": "托克逊县"}]
    }, {
      "v": "650500",
      "n": "哈密市",
      "c": [{"v": "650502", "n": "伊州区"}, {"v": "650521", "n": "巴里坤哈萨克自治县"}, {"v": "650522", "n": "伊吾县"}]
    }, {
      "v": "652300",
      "n": "昌吉回族自治州",
      "c": [{"v": "652301", "n": "昌吉市"}, {"v": "652302", "n": "阜康市"}, {"v": "652323", "n": "呼图壁县"}, {
        "v": "652324",
        "n": "玛纳斯县"
      }, {"v": "652325", "n": "奇台县"}, {"v": "652327", "n": "吉木萨尔县"}, {"v": "652328", "n": "木垒哈萨克自治县"}]
    }, {
      "v": "652700",
      "n": "博尔塔拉蒙古自治州",
      "c": [{"v": "652701", "n": "博乐市"}, {"v": "652702", "n": "阿拉山口市"}, {"v": "652722", "n": "精河县"}, {
        "v": "652723",
        "n": "温泉县"
      }]
    }, {
      "v": "652800",
      "n": "巴音郭楞蒙古自治州",
      "c": [{"v": "652801", "n": "库尔勒市"}, {"v": "652822", "n": "轮台县"}, {"v": "652823", "n": "尉犁县"}, {
        "v": "652824",
        "n": "若羌县"
      }, {"v": "652825", "n": "且末县"}, {"v": "652826", "n": "焉耆回族自治县"}, {"v": "652827", "n": "和静县"}, {
        "v": "652828",
        "n": "和硕县"
      }, {"v": "652829", "n": "博湖县"}]
    }, {
      "v": "652900",
      "n": "阿克苏地区",
      "c": [{"v": "652901", "n": "阿克苏市"}, {"v": "652902", "n": "库车市"}, {"v": "652922", "n": "温宿县"}, {
        "v": "652924",
        "n": "沙雅县"
      }, {"v": "652925", "n": "新和县"}, {"v": "652926", "n": "拜城县"}, {"v": "652927", "n": "乌什县"}, {
        "v": "652928",
        "n": "阿瓦提县"
      }, {"v": "652929", "n": "柯坪县"}]
    }, {
      "v": "653000",
      "n": "克孜勒苏柯尔克孜自治州",
      "c": [{"v": "653001", "n": "阿图什市"}, {"v": "653022", "n": "阿克陶县"}, {"v": "653023", "n": "阿合奇县"}, {
        "v": "653024",
        "n": "乌恰县"
      }]
    }, {
      "v": "653100",
      "n": "喀什地区",
      "c": [{"v": "653101", "n": "喀什市"}, {"v": "653121", "n": "疏附县"}, {"v": "653122", "n": "疏勒县"}, {
        "v": "653123",
        "n": "英吉沙县"
      }, {"v": "653124", "n": "泽普县"}, {"v": "653125", "n": "莎车县"}, {"v": "653126", "n": "叶城县"}, {
        "v": "653127",
        "n": "麦盖提县"
      }, {"v": "653128", "n": "岳普湖县"}, {"v": "653129", "n": "伽师县"}, {"v": "653130", "n": "巴楚县"}, {
        "v": "653131",
        "n": "塔什库尔干塔吉克自治县"
      }]
    }, {
      "v": "653200",
      "n": "和田地区",
      "c": [{"v": "653201", "n": "和田市"}, {"v": "653221", "n": "和田县"}, {"v": "653222", "n": "墨玉县"}, {
        "v": "653223",
        "n": "皮山县"
      }, {"v": "653224", "n": "洛浦县"}, {"v": "653225", "n": "策勒县"}, {"v": "653226", "n": "于田县"}, {
        "v": "653227",
        "n": "民丰县"
      }]
    }, {
      "v": "654000",
      "n": "伊犁哈萨克自治州",
      "c": [{"v": "654002", "n": "伊宁市"}, {"v": "654003", "n": "奎屯市"}, {"v": "654004", "n": "霍尔果斯市"}, {
        "v": "654021",
        "n": "伊宁县"
      }, {"v": "654022", "n": "察布查尔锡伯自治县"}, {"v": "654023", "n": "霍城县"}, {"v": "654024", "n": "巩留县"}, {
        "v": "654025",
        "n": "新源县"
      }, {"v": "654026", "n": "昭苏县"}, {"v": "654027", "n": "特克斯县"}, {"v": "654028", "n": "尼勒克县"}]
    }, {
      "v": "654200",
      "n": "塔城地区",
      "c": [{"v": "654201", "n": "塔城市"}, {"v": "654202", "n": "乌苏市"}, {"v": "654221", "n": "额敏县"}, {
        "v": "654223",
        "n": "沙湾县"
      }, {"v": "654224", "n": "托里县"}, {"v": "654225", "n": "裕民县"}, {"v": "654226", "n": "和布克赛尔蒙古自治县"}]
    }, {
      "v": "654300",
      "n": "阿勒泰地区",
      "c": [{"v": "654301", "n": "阿勒泰市"}, {"v": "654321", "n": "布尔津县"}, {"v": "654322", "n": "富蕴县"}, {
        "v": "654323",
        "n": "福海县"
      }, {"v": "654324", "n": "哈巴河县"}, {"v": "654325", "n": "青河县"}, {"v": "654326", "n": "吉木乃县"}]
    }]
  }, {
    "v": "710000",
    "n": "台湾省",
    "c": [{"v": "710100", "n": "台湾省", "c": [{"v": "710101", "n": "台湾省"}]}]
  }, {
    "v": "810000",
    "n": "香港特别行政区",
    "c": [{
      "v": "810100",
      "n": "香港城区",
      "c": [{"v": "810101", "n": "中西区"}, {"v": "810102", "n": "湾仔区"}, {"v": "810103", "n": "东区"}, {
        "v": "810104",
        "n": "南区"
      }, {"v": "810105", "n": "油尖旺区"}, {"v": "810106", "n": "深水埗区"}, {"v": "810107", "n": "九龙城区"}, {
        "v": "810108",
        "n": "黄大仙区"
      }, {"v": "810109", "n": "观塘区"}, {"v": "810110", "n": "荃湾区"}, {"v": "810111", "n": "屯门区"}, {
        "v": "810112",
        "n": "元朗区"
      }, {"v": "810113", "n": "北区"}, {"v": "810114", "n": "大埔区"}, {"v": "810115", "n": "西贡区"}, {
        "v": "810116",
        "n": "沙田区"
      }, {"v": "810117", "n": "葵青区"}, {"v": "810118", "n": "离岛区"}]
    }]
  }, {
    "v": "820000",
    "n": "澳门特别行政区",
    "c": [{
      "v": "820100",
      "n": "澳门城区",
      "c": [{"v": "820101", "n": "花地玛堂区"}, {"v": "820102", "n": "花王堂区"}, {"v": "820103", "n": "望德堂区"}, {
        "v": "820104",
        "n": "大堂区"
      }, {"v": "820105", "n": "风顺堂区"}, {"v": "820106", "n": "嘉模堂区"}, {"v": "820107", "n": "路凼填海区"}, {
        "v": "820108",
        "n": "圣方济各堂区"
      }]
    }]
  }];
  if (typeof define === "function") {
    define(district)
  } else {
    window.YDUI_DISTRICT = district
  }
}();



// WEBPACK FOOTER //
// ./src/assets/js/city.js